/*
 * Pfotenmond – Personalisierung Herzensanhänger (ohne App)
 * Produktseite: Foto hochladen -> zuschneiden -> Motiv -> Ansicht des Anhängers mit Name.
 * Überall: Warenkorb-Bilder (UpCart-Schublade und /cart) durch die persönliche Vorschau ersetzen.
 * Vertrag (Eigenschaften, Server-API, Geometrie): siehe gravur/SPEC.md
 */
(function () {
  'use strict';
  if (window.PMGravur) return;

  // ------------------------------------------------------------------ Geometrie (mm, _Layout v1)
  // Motivfeld 29.09.26 vergrößert: 1,3 mm unter dem Loch, 0,9 mm über Umlaut-Punkten, 1,8 mm zum Rand.
  var TAG = { w: 24.4, h: 40.8, ry: 6.8, lochX: 12.2, lochY: 3.9, lochR: 1.5,
              feld: { x: 1.6, y: 6.5, w: 21.2, h: 20.8 }, nameY: 31.2, nameMaxB: 19, versal: 3.4 };
  var GRAVUR_DUNKEL = '#2e3034';
  var SCHRIFT = '"Poppins", "Montserrat", "Helvetica Neue", Arial, sans-serif';
  var NAME_ZEICHEN;                                     // zur Laufzeit bauen: alte Browser kennen \p{} nicht
  try { NAME_ZEICHEN = new RegExp("^[\\p{L}\\p{N} .'&-]+$", 'u'); }
  catch (e) { NAME_ZEICHEN = /^[A-Za-zÀ-ÖØ-öø-ɏ0-9 .'&\-]+$/; }   // ohne × und ÷ (keine Buchstaben)
  var NAME_MAX = 12;                                    // Vertrag: höchstens 12 Zeichen (Codepoints, Array.from)
  // Wie vertrag/eigenschaften.js: Leerraum nach Unicode (nicht JS-\s, das zählt U+FEFF mit) und unsichtbare
  // "Buchstaben" (Default_Ignorable, z. B. Hangul-Füllzeichen U+3164) sind im Namen nie erlaubt.
  // Rückfall für alte Browser: dieselben Zeichen als feste Liste (lokal gegen \p{…} geprüft, gravur/test/pruefen.mjs).
  var LEERRAUM, NAME_UNSICHTBAR;
  try { LEERRAUM = new RegExp('\\p{White_Space}+', 'gu'); }
  catch (e) { LEERRAUM = /[\t\n\v\f\r \u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+/g; }
  try { NAME_UNSICHTBAR = new RegExp('\\p{Default_Ignorable_Code_Point}', 'u'); }
  catch (e) {
    NAME_UNSICHTBAR = /[\u00AD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180F\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]/;
  }

  // ------------------------------------------------------------------ Vertrag (SPEC.md, vertrag/testfaelle.json)
  // Motiv-Herkunft: Die Bild-URL wird IMMER aus Server-Adresse + ID gebaut. Werte aus Server-Antwort,
  // Speicher oder Warenkorb werden nur exakt damit verglichen, nie direkt als URL benutzt.
  var API_STANDARD = 'https://pfotenmond-gravur.kontakt-dba.workers.dev';
  var MOTIV_ID = /^[0-9a-f]{32}$/;
  var ALT_PRAEFIX = 'https://upload.cloudlift.app/s/b8f1ed-81/';   // alte App "Live Product Options"
  var ALT_DATEI = /^[A-Za-z0-9]+\.(png|jpe?g)$/;
  var HERZ_ID = '14824150466891';                                  // Herzensanhänger
  // normalisierter Schlüssel -> erlaubte Schreibweisen (neu und alt)
  var SCHLUESSEL = { 'name': ['Name'], '_motiv': ['_Motiv'], '_foto': ['_Foto', '_foto'], '_motiv-id': ['_Motiv-ID'],
                     '_layout': ['_Layout'], '_demo': ['_Demo'], '_name': ['_Name:'], '_preview': ['_preview'] };
  var NEUE_SCHLUESSEL = ['_Motiv', '_Motiv-ID', '_Layout', '_Foto', 'Name'], NUR_ALT = ['_preview', '_Name:'];

  // Server-Adresse: Produktseite = data-config des Blocks, Warenkorb-Seiten = data-pmg-api am Skript-Tag
  // (beides aus snippets/pm-gravur-api.liquid), sonst die feste Adresse.
  function apiAdresse() {
    var api = '';
    var r = document.querySelector('[data-pm-gravur][data-config]');
    if (r) { try { api = JSON.parse(r.getAttribute('data-config') || '{}').api || ''; } catch (e) {} }
    if (!api) { var s = document.querySelector('script[data-pmg-api]'); if (s) api = s.getAttribute('data-pmg-api') || ''; }
    return String(api || API_STANDARD).replace(/\/+$/, '');
  }
  function bildBasis(api) { return (api ? String(api).replace(/\/+$/, '') : apiAdresse()) + '/v1/bild/'; }
  function motivUrlGueltig(url, id, api) {
    return typeof id === 'string' && MOTIV_ID.test(id) && typeof url === 'string' && url === bildBasis(api) + id + '/motiv';
  }
  // Gravurtext: NFC, Unicode-Leerraum zu einem Leerzeichen zusammenfassen, trimmen
  function sauberName(v) {
    var s = v == null ? '' : String(v);
    if (s.normalize) { try { s = s.normalize('NFC'); } catch (e) {} }
    return s.replace(LEERRAUM, ' ').trim();
  }
  function nameGueltig(n) {
    return !!n && NAME_ZEICHEN.test(n) && !NAME_UNSICHTBAR.test(n) && Array.from(n).length <= NAME_MAX;
  }
  function nameKappen(n) { return Array.from(n || '').slice(0, NAME_MAX).join(''); }
  function eigenschaftenListe(e) {
    if (Array.isArray(e)) return e.map(function (p) {
      return Array.isArray(p) ? [p[0], p[1]] : [p && (p.key != null ? p.key : p.name), p && p.value];
    });
    return e && typeof e === 'object' ? Object.keys(e).map(function (k) { return [k, e[k]]; }) : [];
  }
  // Produkt-ID wie vertrag/eigenschaften.js: Zahl, Zahl als Text oder GraphQL-ID -> "14824150466891", sonst '' (unbekannt)
  function produktNummer(p) {
    if (typeof p === 'number') return p > 0 && p % 1 === 0 && p <= 9007199254740991 ? String(p) : '';
    var t = typeof p === 'string' ? /^(?:gid:\/\/shopify\/Product\/)?([1-9][0-9]{0,19})$/.exec(p.trim()) : null;
    return t ? t[1] : '';
  }
  /* Status einer Warenkorb-/Bestellzeile nach dem gemeinsamen Vertrag:
     ok | alt | fremd | konflikt | demo | fehlt | keine. bild nur bei ok (gebaut) und alt (_preview). */
  function gravurStatus(eigenschaften, produktId, api) {
    var basis = bildBasis(api), norm = {}, roh = {}, namen = {}, konflikt = false, hatVertrag = false;
    eigenschaftenListe(eigenschaften).forEach(function (p) {
      var k = p[0] == null ? '' : String(p[0]);
      var n = k.trim().toLowerCase().replace(/[:\s]+$/, '');
      if (!SCHLUESSEL.hasOwnProperty(n)) return;
      var wert = p[1] == null ? '' : String(p[1]);
      hatVertrag = true; roh[k] = true;
      if (norm.hasOwnProperty(n)) konflikt = true;                         // Schlüssel doppelt
      else norm[n] = wert;
      if (n !== '_demo' && SCHLUESSEL[n].indexOf(k) < 0) konflikt = true; // falsche Schreibweise
      // Name wie im Vertragsmodul: zuerst "Name", dann "_Name:", sonst die erste andere Schreibweise
      var art = k === 'Name' ? 'neu' : k === '_Name:' ? 'alt' : (n === 'name' || n === '_name') ? 'sonst' : '';
      if (art && !namen.hasOwnProperty(art)) namen[art] = wert;
    });
    var name = sauberName(namen.hasOwnProperty('neu') ? namen.neu : namen.hasOwnProperty('alt') ? namen.alt : namen.sonst);
    var erg = { status: '', bild: null, name: name, nameOk: nameGueltig(name) };
    function mit(s, b) { erg.status = s; erg.bild = b || null; return erg; }
    if (konflikt) return mit('konflikt');
    if (norm.hasOwnProperty('_demo')) return mit('demo');
    var pid = produktNummer(produktId);
    if (!hatVertrag) return mit(pid === HERZ_ID ? 'fehlt' : 'keine');
    if (pid && pid !== HERZ_ID) return mit('konflikt');
    var neu = NEUE_SCHLUESSEL.some(function (k) { return roh[k]; }), alt = NUR_ALT.some(function (k) { return roh[k]; });
    if (neu && alt) return mit('konflikt');
    if (neu) {
      var id = norm['_motiv-id'] || '';
      if (!MOTIV_ID.test(id) || norm._motiv !== basis + id + '/motiv') return mit('fremd');
      if (norm.hasOwnProperty('_foto') && norm._foto !== basis + id + '/foto') return mit('konflikt');
      return mit('ok', basis + id + '/motiv');
    }
    var v = norm._preview || '';
    if (v.indexOf(ALT_PRAEFIX) === 0 && ALT_DATEI.test(v.slice(ALT_PRAEFIX.length))) return mit('alt', v);
    return mit('fremd');
  }

  // ------------------------------------------------------------------ Hilfen
  function el(tag, attrs, kinder) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') e.textContent = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (attrs[k] !== false && attrs[k] != null) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kinder || []).forEach(function (k) { if (k) e.appendChild(k); });
    return e;
  }
  function klemme(v, a, b) { return Math.max(a, Math.min(b, v)); }
  // Nächster Frame – mit Zeitgeber als Rückfall, falls der Browser gerade nicht zeichnet (Tab im Hintergrund)
  function naechsterFrame(fn) {
    var fertig = false;
    function los() { if (!fertig) { fertig = true; fn(); } }
    if (window.requestAnimationFrame) requestAnimationFrame(los);
    setTimeout(los, 80);
  }
  function speicherLesen(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function speicherSchreiben(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function zufallsId() {
    var a = new Uint8Array(12); (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
  }
  function bildLaden(src, cors) {
    return new Promise(function (ok, fehl) {
      var i = new Image();
      if (cors) i.crossOrigin = 'anonymous';
      i.decoding = 'async';
      i.onload = function () { ok(i); };
      i.onerror = function () { fehl(new Error('bild')); };
      i.src = src;
    });
  }
  var ICON = {
    korb: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 4.5h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h7.9a1.5 1.5 0 0 0 1.5-1.1l1.4-6.3H6.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="19.5" r="1.4" fill="currentColor"/><circle cx="17" cy="19.5" r="1.4" fill="currentColor"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    papierkorb: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9.5 7V5.2c0-.66.54-1.2 1.2-1.2h2.6c.66 0 1.2.54 1.2 1.2V7M6.3 7l.85 11.6a1.6 1.6 0 0 0 1.6 1.5h6.5a1.6 1.6 0 0 0 1.6-1.5L17.7 7M10 10.5v6M14 10.5v6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    auge: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    lupe: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M15 15l5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    pfote: '<svg viewBox="0 0 24 24" aria-hidden="true"><ellipse cx="12" cy="16.2" rx="4.6" ry="3.9"/><ellipse cx="6.2" cy="10.4" rx="1.9" ry="2.4"/><ellipse cx="9.6" cy="6.6" rx="1.9" ry="2.5"/><ellipse cx="14.4" cy="6.6" rx="1.9" ry="2.5"/><ellipse cx="17.8" cy="10.4" rx="1.9" ry="2.4"/></svg>'
  };

  // ------------------------------------------------------------------ Metall-Textur (einmal erzeugt)
  var buerstung = null;
  function buerstMuster() {
    if (buerstung) return buerstung;
    var c = document.createElement('canvas'); c.width = 512; c.height = 256;
    var x = c.getContext('2d'), s = 7;
    function zufall() { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }
    for (var i = 0; i < 900; i++) {
      var y = zufall() * 256, l = 40 + zufall() * 420, x0 = zufall() * 512 - 60;
      x.fillStyle = zufall() > .5 ? 'rgba(255,255,255,' + (0.05 + zufall() * 0.09) + ')' : 'rgba(0,0,0,' + (0.025 + zufall() * 0.05) + ')';
      x.fillRect(x0, y, l, 0.6 + zufall() * 0.8);
    }
    buerstung = c; return c;
  }

  // ------------------------------------------------------------------ Strichzeichnung -> Gravur-Ebenen
  // Weißer Hintergrund wird transparent, Linien behalten weiche Kanten.
  // Einpassung (SPEC "Motiv-Einpassung", gilt auch für die Gravur-Station): Zeichnung auf ihren
  // Inhalt zuschneiden und mit 1 % Rand mittig ins Feld setzen – jeder Anhänger wirkt gleich groß.
  var EINPASS_RAND = 0.01, EINPASS_MAX = 2.5;
  function inhaltsRahmen(x, n) {
    var p = x.getImageData(0, 0, n, n).data, zeilen = new Uint16Array(n), spalten = new Uint16Array(n);
    for (var y = 0; y < n; y++) {
      for (var xx = 0; xx < n; xx++) {
        var i = (y * n + xx) * 4;
        if (0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2] < 160) { zeilen[y]++; spalten[xx]++; }
      }
    }
    function grenzen(a) { var v = 0, b = n - 1; while (v < n && a[v] < 3) v++; while (b > v && a[b] < 3) b--; return [v, b]; }
    var gy = grenzen(zeilen), gx = grenzen(spalten);
    if (gx[1] - gx[0] < 20 || gy[1] - gy[0] < 20) return null;
    return { x: gx[0], y: gy[0], w: gx[1] - gx[0] + 1, h: gy[1] - gy[0] + 1 };
  }
  // Ergebnis-Ebenen haben das Seitenverhältnis des Motivfelds: 900 x round(900 * h / w) Pixel.
  function gravurEbenen(bild) {
    var n = 900, m = Math.round(n * TAG.feld.h / TAG.feld.w);
    var c = document.createElement('canvas'); c.width = n; c.height = m;
    var x = c.getContext('2d', { willReadFrequently: true });
    var q = document.createElement('canvas'); q.width = q.height = n;
    var qx = q.getContext('2d', { willReadFrequently: true });
    qx.fillStyle = '#fff'; qx.fillRect(0, 0, n, n);
    var s = Math.min(n / bild.naturalWidth, n / bild.naturalHeight);
    var w = bild.naturalWidth * s, h = bild.naturalHeight * s;
    qx.drawImage(bild, (n - w) / 2, (n - h) / 2, w, h);
    x.fillStyle = '#fff'; x.fillRect(0, 0, n, m);
    var r = inhaltsRahmen(qx, n);
    if (r) {
      var zielB = n * (1 - 2 * EINPASS_RAND), zielH = m * (1 - 2 * EINPASS_RAND);
      var f = Math.min(zielB / r.w, zielH / r.h, EINPASS_MAX);
      var w2 = r.w * f, h2 = r.h * f;
      x.drawImage(q, r.x, r.y, r.w, r.h, (n - w2) / 2, (m - h2) / 2, w2, h2);
    } else {
      var s2 = Math.min(1, m / n);
      x.drawImage(q, (n - n * s2) / 2, (m - n * s2) / 2, n * s2, n * s2);
    }
    var d = x.getImageData(0, 0, n, m), p = d.data;
    var dunkel = x.createImageData(n, m), hell = x.createImageData(n, m), a = dunkel.data, b = hell.data;
    for (var i = 0; i < p.length; i += 4) {
      var L = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2];
      var al = klemme((226 - L) / 150, 0, 1);
      al = al * al * (3 - 2 * al);                      // weiche, aber klare Kante
      a[i] = 46; a[i + 1] = 48; a[i + 2] = 52; a[i + 3] = al * 255;
      b[i] = 255; b[i + 1] = 255; b[i + 2] = 255; b[i + 3] = al * 150;
    }
    var cd = document.createElement('canvas'), ch = document.createElement('canvas');
    cd.width = ch.width = n; cd.height = ch.height = m;
    cd.getContext('2d').putImageData(dunkel, 0, 0); ch.getContext('2d').putImageData(hell, 0, 0);
    return { dunkel: cd, hell: ch };
  }

  // ------------------------------------------------------------------ Anhänger zeichnen
  function tagPfad(x, ox, oy, k) {
    var w = TAG.w * k, h = TAG.h * k, rx = w / 2, ry = TAG.ry * k;
    x.beginPath();
    x.moveTo(ox, oy + ry);
    x.ellipse(ox + rx, oy + ry, rx, ry, 0, Math.PI, 2 * Math.PI);
    x.lineTo(ox + w, oy + h - ry);
    x.ellipse(ox + rx, oy + h - ry, rx, ry, 0, 0, Math.PI);
    x.closePath();
  }
  function schriftGroesse(x, text, px) {
    x.font = '600 ' + px + 'px ' + SCHRIFT;
    return x.measureText(text).width;
  }
  function textGesperrt(x, text, cx, cy, px, sperr, maxB) {
    var zeichen = Array.from(text), g = px, breite;
    for (var t = 0; t < 30; t++) {
      x.font = '600 ' + g + 'px ' + SCHRIFT;
      breite = zeichen.reduce(function (s, z) { return s + x.measureText(z).width; }, 0) + g * sperr * (zeichen.length - 1);
      if (breite <= maxB || g < px * 0.45) break;
      g *= 0.94;
    }
    var xx = cx - breite / 2;
    x.textBaseline = 'middle'; x.textAlign = 'left';
    zeichen.forEach(function (z) { x.fillText(z, xx, cy); xx += x.measureText(z).width + g * sperr; });
  }

  /* opts: { motiv: {dunkel, hell} | null, name, art: 'galerie' | 'thumb', hintergrund: true } */
  function zeichneAnhaenger(c, opts) {
    var x = c.getContext('2d'), W = c.width, H = c.height;
    x.save(); x.clearRect(0, 0, W, H);
    var mitRing = opts.art !== 'thumb';
    var gesamt = mitRing ? 62.6 : 44;                     // mm Höhe inkl. Ring (Ring ragt 21,8 mm über den Anhänger)
    var k = (H * (mitRing ? 0.84 : 0.9)) / gesamt;
    var tw = TAG.w * k, th = TAG.h * k;
    var ox = (W - tw) / 2, oy = mitRing ? (H - gesamt * k) / 2 + 21.8 * k : (H - th) / 2;

    if (opts.hintergrund !== false) {
      var bg = x.createRadialGradient(W * 0.5, H * 0.42, W * 0.05, W * 0.5, H * 0.5, W * 0.75);
      bg.addColorStop(0, '#fbfaf8'); bg.addColorStop(1, '#ebe8e3');
      x.fillStyle = bg; x.fillRect(0, 0, W, H);
    }
    var lx = ox + TAG.lochX * k, ly = oy + TAG.lochY * k;

    if (mitRing) {                                           // Schlüsselring
      var R = 11.6 * k, rcx = lx, rcy = ly - 2.1 * k - R - 0.4 * k;
      x.save();
      x.shadowColor = 'rgba(40,36,30,.16)'; x.shadowBlur = 1.4 * k; x.shadowOffsetY = 0.6 * k;
      var rg = x.createLinearGradient(rcx - R, rcy - R, rcx + R, rcy + R);
      rg.addColorStop(0, '#f6f7f8'); rg.addColorStop(0.3, '#b9bec4'); rg.addColorStop(0.55, '#eef0f2');
      rg.addColorStop(0.8, '#a8aeb5'); rg.addColorStop(1, '#e3e6e9');
      x.lineWidth = 1.5 * k; x.strokeStyle = rg;
      x.beginPath(); x.arc(rcx, rcy, R, 0, Math.PI * 2); x.stroke();
      x.restore();
      x.lineWidth = 0.35 * k; x.strokeStyle = 'rgba(255,255,255,.75)';
      x.beginPath(); x.arc(rcx, rcy, R - 0.35 * k, Math.PI * 1.05, Math.PI * 1.6); x.stroke();
      x.strokeStyle = 'rgba(0,0,0,.12)';
      x.beginPath(); x.arc(rcx, rcy, R + 0.5 * k, Math.PI * 0.1, Math.PI * 0.55); x.stroke();
      // kleiner Verbindungsring (hinterer Teil, vom Anhänger verdeckt)
      x.lineWidth = 0.75 * k; x.strokeStyle = '#9aa1a8';
      x.beginPath(); x.ellipse(lx, ly - 1.5 * k, 1.35 * k, 2.6 * k, 0, 0, Math.PI * 2); x.stroke();
    }

    // Schatten + Grundform
    x.save();
    x.shadowColor = 'rgba(38,33,26,.20)'; x.shadowBlur = 2.6 * k; x.shadowOffsetY = 1.1 * k;
    tagPfad(x, ox, oy, k);
    var mg = x.createLinearGradient(ox, oy, ox + tw, oy + th);
    mg.addColorStop(0, '#eceef0'); mg.addColorStop(0.28, '#d5d9dd'); mg.addColorStop(0.5, '#f5f6f7');
    mg.addColorStop(0.72, '#cdd1d6'); mg.addColorStop(1, '#e7e9eb');
    x.fillStyle = mg; x.fill();
    x.restore();
    x.save(); tagPfad(x, ox, oy, k); x.clip();
    var pat = x.createPattern(buerstMuster(), 'repeat');
    x.globalAlpha = 0.85; x.fillStyle = pat; x.fillRect(ox, oy, tw, th); x.globalAlpha = 1;
    var glanz = x.createLinearGradient(ox, oy, ox + tw * 0.9, oy + th);
    glanz.addColorStop(0, 'rgba(255,255,255,.35)'); glanz.addColorStop(0.45, 'rgba(255,255,255,0)');
    glanz.addColorStop(0.6, 'rgba(255,255,255,.18)'); glanz.addColorStop(1, 'rgba(255,255,255,0)');
    x.fillStyle = glanz; x.fillRect(ox, oy, tw, th);
    x.restore();
    // Kanten
    x.lineWidth = Math.max(1, 0.28 * k); x.strokeStyle = 'rgba(70,74,80,.35)'; tagPfad(x, ox, oy, k); x.stroke();
    x.save(); x.translate(ox + tw / 2, oy + th / 2); x.scale(0.965, 0.978); x.translate(-(ox + tw / 2), -(oy + th / 2));
    x.lineWidth = Math.max(1, 0.22 * k); x.strokeStyle = 'rgba(255,255,255,.7)'; tagPfad(x, ox, oy, k); x.stroke(); x.restore();

    // Loch
    x.save();
    x.beginPath(); x.arc(lx, ly, TAG.lochR * k, 0, Math.PI * 2);
    x.fillStyle = opts.hintergrund === false ? '#f3f2ef' : '#ece9e4'; x.fill();
    x.lineWidth = Math.max(1, 0.3 * k); x.strokeStyle = 'rgba(60,64,70,.45)'; x.stroke();
    x.restore();
    if (mitRing) {                                           // vorderer Teil des Verbindungsrings
      x.lineWidth = 0.75 * k; x.strokeStyle = '#c9cdd2';
      x.beginPath(); x.ellipse(lx, ly - 1.5 * k, 1.35 * k, 2.6 * k, 0, Math.PI * 1.05, Math.PI * 1.95); x.stroke();
    }

    // Motiv
    var f = TAG.feld, fx = ox + f.x * k, fy = oy + f.y * k, fw = f.w * k, fh = f.h * k;
    if (opts.motiv) {
      x.save(); x.globalAlpha = 0.9;
      x.drawImage(opts.motiv.hell, fx, fy + Math.max(1, 0.09 * k), fw, fh);
      x.globalAlpha = 1; x.drawImage(opts.motiv.dunkel, fx, fy, fw, fh);
      x.restore();
    } else if (opts.platzhalter !== false) {
      x.save();
      x.setLineDash([0.9 * k, 0.75 * k]); x.lineWidth = Math.max(1, 0.22 * k); x.strokeStyle = 'rgba(46,48,52,.28)';
      var r = 2.2 * k, px = fx + 2.6 * k, py = fy + 1.6 * k, pw = fw - 5.2 * k, ph = fh - 3.2 * k;
      x.beginPath(); x.moveTo(px + r, py); x.arcTo(px + pw, py, px + pw, py + ph, r); x.arcTo(px + pw, py + ph, px, py + ph, r);
      x.arcTo(px, py + ph, px, py, r); x.arcTo(px, py, px + pw, py, r); x.closePath(); x.stroke();
      x.setLineDash([]); x.fillStyle = 'rgba(46,48,52,.32)';
      x.font = '500 ' + (1.7 * k) + 'px ' + SCHRIFT; x.textAlign = 'center'; x.textBaseline = 'middle';
      x.fillText('Dein Motiv', fx + fw / 2, fy + fh / 2);
      x.restore();
    }

    // Name (höchstens 12 Zeichen – auch wenn der Wert aus dem Warenkorb zurückgelesen wird)
    var name = nameKappen(sauberName(opts.name)).toUpperCase();
    var zeige = name || (opts.platzhalter !== false ? 'NAME' : '');
    if (zeige) {
      var px2 = (TAG.versal / 0.7) * k, cy = oy + TAG.nameY * k, maxB = TAG.nameMaxB * k;
      x.save();
      x.fillStyle = 'rgba(255,255,255,.6)';
      if (name) textGesperrt(x, zeige, ox + tw / 2, cy + Math.max(1, 0.09 * k), px2, 0.06, maxB);
      x.fillStyle = name ? GRAVUR_DUNKEL : 'rgba(46,48,52,.28)';
      textGesperrt(x, zeige, ox + tw / 2, cy, px2, 0.06, maxB);
      x.restore();
    }
    x.restore();
  }

  window.PMGravur = {
    zeichneAnhaenger: zeichneAnhaenger, gravurEbenen: gravurEbenen, TAG: TAG,
    vertrag: { status: gravurStatus, motivUrlGueltig: motivUrlGueltig, sauberName: sauberName, nameGueltig: nameGueltig },
    _muster: { leerraum: LEERRAUM, unsichtbar: NAME_UNSICHTBAR }, // nur für die lokalen Tests (Rückfall alter Browser)
    _teile: { TierAuswahl: TierAuswahl, WarenkorbUebergabe: WarenkorbUebergabe } // nur für die lokalen Tests
  };

  // ================================================================== Übergabe an den Warenkorb
  // Architektur-Durchsicht 02.10.26, Vorschlag 1: alles, was Anhänger in den Warenkorb bringt, steht hier – der UpCart-
  // Haken (gleich unten, wird wie bisher beim Laden des Skripts gesetzt), Formular und Knopf des Themes, die versteckten
  // Vertragsfelder für EIN Tier, die Sperren (Doppelklick nach dem Knopf im großen Fenster, laufende Übergabe), die Wahl
  // des Wegs, die eigene Anfrage mit Meldungen und Zeitlimit und das Vorbereiten bzw. Vormerken der Warenkorb-Bilder.
  // Weg: genau EIN Anhänger -> Formular des Themes (UpCart schickt es mit unseren versteckten Feldern); sonst (mehrere
  // Tiere oder Anzahl > 1) alle in EINER Anfrage an /cart/add.js (fetch, damit Klaviyo „Added to Cart“ sieht); UpCart
  // öffnet bei jeder Anfrage an /cart/add von selbst seinen Warenkorb, ohne UpCart geht es auf /cart.
  // Die Personalisierung prüft vorher nur, ob alles da ist (Motive, Namen), und ruft dann uebergeben(e).
  // UpCart (AfterSell) fragt vor jedem Warenkorb-Klick window.upcartShouldAddToCartContinue(evt). Ab zwei Anhängern legt
  // die Übergabe alle Anhänger selbst in den Warenkorb und markiert den Klick (evt.__pmgMehrere): dann
  // überspringt UpCart ihn – der Klick erreicht trotzdem den Knopf (Outbrain, Klaviyo zählen weiter). Ein schon
  // vorhandener Haken (anderes Skript) bleibt erhalten und entscheidet in allen anderen Fällen.
  (function () {
    var vorher = window.upcartShouldAddToCartContinue;
    window.upcartShouldAddToCartContinue = function (evt) {
      if (evt && evt.__pmgMehrere) return false;
      return typeof vorher === 'function' ? vorher.apply(this, arguments) : true;
    };
  })();

  /**
   * @param {{root: Element, produktId: *, uid: string, auswahl: object, melden: function(string), hinweisWeg: function,
   *   ansagen: function(string)}} opts  root: hier hängen die versteckten Felder; auswahl: TierAuswahl
   */
  function WarenkorbUebergabe(opts) {
    var root = opts.root, auswahl = opts.auswahl, melden = opts.melden;
    // Warenkorb-Felder (Vertrag) für das ERSTE Tier: Name, _Motiv, _Motiv-ID, _Layout, im Demo-Modus _Demo. Kein _Foto.
    var felder = {};
    ['Name', '_Motiv', '_Motiv-ID', '_Layout', '_Demo'].forEach(function (k) {
      felder[k] = el('input', { type: 'hidden', name: 'properties[' + k + ']', disabled: true });
    });
    Object.keys(felder).forEach(function (k) { root.appendChild(felder[k]); });

    var formular = null;
    function findeFormular() {
      if (formular && document.contains(formular)) return formular;
      var sek = root.closest('.product-section') || document;
      var pid = opts.produktId ? String(opts.produktId) : '';
      formular = (pid && sek.querySelector('form[action*="/cart/add"][id$="-' + pid + '"]')) ||
                 sek.querySelector('form[action*="/cart/add"]') ||
                 document.querySelector('form[action*="/cart/add"]');
      if (formular) {
        var id = formular.getAttribute('id');                 // formular.id wäre das Feld name="id"
        if (!id) { id = 'pmg-form-' + opts.uid; formular.setAttribute('id', id); }
        Object.keys(felder).forEach(function (k) { felder[k].setAttribute('form', id); });
      }
      return formular;
    }
    function felderSetzen() {
      var werte = auswahl.einzelFelder();
      Object.keys(felder).forEach(function (k) {         // leere Felder deaktivieren = werden nicht gesendet
        var v = werte[k] || '';
        felder[k].value = v; felder[k].disabled = !v;
      });
    }
    // Der "In den Warenkorb"-Knopf des Themes: über ihn laufen UpCart, Theme und die Prüfung der Personalisierung
    // genau wie bei einem normalen Klick – kein eigener Warenkorb-Aufruf bei einem Anhänger.
    function themeKorbKnopf() {
      var f = findeFormular(); if (!f) return null;
      var k = f.querySelector('button[type="submit"][name="add"]') || f.querySelector('button[type="submit"], input[type="submit"]');
      var id = f.getAttribute('id');
      if (!k && id) k = document.querySelector('button[type="submit"][form="' + id + '"], input[type="submit"][form="' + id + '"]');
      return k;
    }
    // Capture-Phase am document (Personalisierung): läuft vor UpCart (Capture am Knopf) und vor dem Theme.
    // Gesperrt wird nur, wenn etwas fehlt – sonst laufen UpCart, Klaviyo und Outbrain ganz normal.
    function istWarenkorbKnopf(e) {
      var f = findeFormular(); if (!f) return false;
      if (e.type === 'submit') return e.target === f;
      var k = e.target && e.target.closest && e.target.closest('button, input[type="submit"]');
      return !!(k && k.form === f && k.type === 'submit' && !k.disabled);
    }
    function sperren(e) { e.preventDefault(); e.stopImmediatePropagation(); }
    var korbAusFensterZeit = 0, korbLaeuft = false;
    function bildVorbereiten(t) { vorschauAusEbenen(t.motivUrl, nameKappen(sauberName(auswahl.nameVon(t))), t.motiv); }

    function variantenId(f) {
      var v = '';
      try { v = String(new FormData(f).get('id') || ''); } catch (e) {}
      return /^[1-9][0-9]{0,19}$/.test(v) ? Number(v) : 0;
    }
    // weitere properties[…] im Formular (andere Apps) wie beim Klick über UpCart mitgeben – unsere eigenen nie
    function andereEigenschaften(f) {
      var x = {};
      try {
        new FormData(f).forEach(function (v, k) {
          var m = /^properties\[(.+)\]$/.exec(k);
          if (!m || typeof v !== 'string' || ['Name', '_Motiv', '_Motiv-ID', '_Layout', '_Demo', '_Foto'].indexOf(m[1]) >= 0) return;
          x[m[1]] = v;
        });
      } catch (e) {}
      return x;
    }
    function mehrereInWarenkorb() {
      var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var f = findeFormular(), vid = f ? variantenId(f) : 0;
      if (!vid) { korbLaeuft = false; melden('Das hat leider nicht geklappt. Bitte lade die Seite neu und versuche es noch einmal.'); return; }
      var extra = andereEigenschaften(f);
      var zeilen = auswahl.tiere.map(function (t) {
        bildVorbereiten(t);                               // Warenkorb-Bilder sofort bereit
        return auswahl.zeile(t, vid, extra);
      });
      opts.hinweisWeg();
      var fertig = false;
      function ende() { fertig = true; korbLaeuft = false; }
      var uhr = setTimeout(function () {
        if (fertig) return;
        ende();
        melden('Das dauert gerade ungewöhnlich lange. Bitte sieh im Warenkorb nach, bevor du es noch einmal versuchst.');
      }, 30000);
      function fehlgeschlagen(text) {
        if (fertig) return;
        clearTimeout(uhr); ende();
        melden('Deine Anhänger konnten nicht in den Warenkorb gelegt werden. ' + (text ? text + ' ' : '') + 'Bitte versuche es noch einmal.');
      }
      var anfrage;
      // fetch statt XMLHttpRequest: so sieht Klaviyo („Added to Cart“) die Anfrage wie bei UpCart
      try {
        anfrage = fetch(wurzel + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: zeilen })
        });
      } catch (e) { fehlgeschlagen(''); return; }
      anfrage.then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!r.ok) { var e = new Error('warenkorb'); e.text = j && typeof j.description === 'string' && j.description.length < 300 ? j.description : ''; throw e; }
          return j;
        });
      }).then(function (j) {
        if (fertig) return;
        clearTimeout(uhr); ende();
        zeilenVormerken(j && j.items); upcartAnwenden();   // neue Zeilen bekommen ihr Bild gleich beim Einfügen
        opts.ansagen(zeilen.reduce(function (s, z) { return s + z.quantity; }, 0) + ' Anhänger liegen jetzt im Warenkorb.');
        // Ohne UpCart öffnet sich kein Warenkorb von selbst: dann zur Warenkorb-Seite
        if (typeof window.upcartOpenCart !== 'function') location.href = wurzel + 'cart';
      }).catch(function (err) { fehlgeschlagen(err && err.text); });
    }

    return {
      findeFormular: findeFormular,
      felderSetzen: felderSetzen,
      themeKnopf: themeKorbKnopf,
      sperren: sperren,
      istKorbEreignis: istWarenkorbKnopf,
      // „In den Warenkorb legen“ im großen Fenster: gleich klickt die Personalisierung den Theme-Knopf
      ausFenster: function () { korbAusFensterZeit = Date.now(); },
      // true = Ereignis gesperrt (und schon abgefangen)
      gesperrt: function (e) {
        // Zweiter Klick eines Doppelklicks direkt nach "In den Warenkorb legen" im Fenster: ignorieren.
        // (Unser eigener Klick auf den Theme-Knopf ist nicht isTrusted und geht durch.)
        if (e.type === 'click' && e.isTrusted && Date.now() - korbAusFensterZeit < 1200) { sperren(e); return true; }
        if (korbLaeuft) { sperren(e); return true; }      // mehrere Anhänger werden gerade hineingelegt
        return false;
      },
      // Alles geprüft: Weg wählen und übergeben
      uebergeben: function (e) {
        if (!auswahl.selbstInKorb()) {                    // EIN Anhänger: wie bisher über UpCart und Theme
          felderSetzen();                                 // Werte frisch in die versteckten Felder
          bildVorbereiten(auswahl.tiere[0]);              // Warenkorb-Bild sofort bereit
          return;
        }
        // Ab zwei Anhängern (mehrere Tiere oder Anzahl > 1): alle selbst hineinlegen. Der Klick läuft weiter zum Knopf
        // (Outbrain, Klaviyo), aber ohne Formular-Absenden (preventDefault) und ohne UpCart (Markierung, siehe
        // upcartShouldAddToCartContinue).
        if (e.type === 'submit') sperren(e);
        else { e.preventDefault(); e.__pmgMehrere = true; }
        korbLaeuft = true;
        setTimeout(mehrereInWarenkorb, 0);
      }
    };
  }

  // ================================================================== Tier-Auswahl (ohne Bildschirm)
  // Architektur-Durchsicht 02.10.26, Vorschlag 2: was auf der Produktseite gewählt ist und alle Regeln dazu – die
  // Tiere in Reihenfolge, welches gewählt ist, die Anzahl je Tier (Inhaber 02.10.26: derselbe Anhänger mehrmals = EINE
  // Zeile mit dieser Menge; die Gravur-Station gibt jedem Stück einen eigenen Platz), höchstens maxTiere (5) Tiere und
  // maxStueck (10) Stück, die Summe, ob selbst in den Warenkorb gelegt wird, die Speicherform (Neuladen der Seite), die
  // Warenkorb-Zeilen und die Vertragsfelder für EIN Tier. Ein Tier ist ein Objekt der Personalisierung; gelesen werden
  // hier nur seine Daten (phase, laedt, motivUrl, id, menge) und über nameVon(t) der Name aus seinem Eingabefeld – so
  // hat der Name genau eine Quelle. Kein DOM: ohne Seite prüfbar (PMGravur._teile.TierAuswahl, gravur/test/pruefen.mjs).
  function TierAuswahl(opts) {
    var MAX_TIERE = klemme(parseInt(opts.maxTiere, 10) || 5, 1, 5);
    var MAX_STUECK = klemme(parseInt(opts.maxStueck, 10) || 10, 1, 10);   // Anzahl je Tier (1 schaltet die Auswahl ab)
    var DEMO = !!opts.demo, nameVon = opts.nameVon;
    var tiere = [], aktivIdx = 0;
    function mehrere() { return tiere.length > 1; }
    function stueckGesamt() { return tiere.reduce(function (s, t) { return s + t.menge; }, 0); }
    // Merken: ein Tier { name, motiv } wie bisher; mehrere zusätzlich tiere: [{ name, motiv }, …] (name/motiv = Tier 1);
    // Anzahl über 1: zusätzlich menge (beim Tier bzw. im Listeneintrag) – bei Anzahl 1 bleibt die Form genau wie bisher.
    function motivZumMerken(t) { return t.phase === 'fertig' && !DEMO ? { url: t.motivUrl, id: t.id } : null; }
    function eintragZumMerken(t) {
      var e = { name: nameVon(t), motiv: motivZumMerken(t) };
      if (t.menge > 1) e.menge = t.menge;
      return e;
    }
    return {
      tiere: tiere,                                       // nur lesen; ändern über die Methoden hier
      nameVon: nameVon,
      MAX_TIERE: MAX_TIERE,
      MAX_STUECK: MAX_STUECK,
      aktiv: function () { return tiere[aktivIdx] || tiere[0]; },
      nummer: function (t) { return tiere.indexOf(t) + 1; },
      mehrere: mehrere,
      stueckGesamt: stueckGesamt,
      // Mehr als EIN Anhänger (mehrere Tiere oder Anzahl > 1): dann legt die Übergabe selbst in den Warenkorb
      selbstInKorb: function () { return mehrere() || stueckGesamt() > 1; },
      // Das Feld „Du hast noch einen Liebling?“ erscheint, sobald jedes Tier ein Foto hat, dessen Motiv entsteht oder
      // fertig ist (nicht bei einem fehlgeschlagenen Motiv), und noch Platz ist.
      neuErlaubt: function () {
        return tiere.length < MAX_TIERE && tiere.every(function (t) { return t.laedt || t.phase === 'laeuft' || t.phase === 'fertig'; });
      },
      voll: function () { return tiere.length >= MAX_TIERE; },
      anhaengen: function (t) { tiere.push(t); },
      neuAnhaengen: function (t) { tiere.push(t); aktivIdx = tiere.length - 1; },
      // Tier wählen (die Vorschau zeigt es): true, wenn sich die Wahl geändert hat
      waehlen: function (t) {
        var i = tiere.indexOf(t);
        if (i < 0 || i === aktivIdx) return false;
        aktivIdx = i;
        return true;
      },
      // Tier entfernen (es muss in der Liste sein); gewählt bleibt dieselbe Stelle. Liefert die Stelle für „Rückgängig“.
      entfernen: function (t) {
        var idx = tiere.indexOf(t);
        tiere.splice(idx, 1);
        aktivIdx = Math.min(idx, tiere.length - 1);
        return idx;
      },
      // „Rückgängig“: zurück an seine Stelle, wenn es nicht schon da ist und noch Platz ist
      zurueckholen: function (t, idx) {
        if (tiere.indexOf(t) >= 0 || tiere.length >= MAX_TIERE) return false;
        tiere.splice(Math.min(idx, tiere.length), 0, t);
        aktivIdx = tiere.indexOf(t);
        return true;
      },
      // Anzahl setzen (1 bis MAX_STUECK): true, wenn sie sich geändert hat
      mengeSetzen: function (t, n) {
        n = klemme(n, 1, MAX_STUECK);
        if (tiere.indexOf(t) < 0 || n === t.menge) return false;
        t.menge = n;
        return true;
      },
      // Summe unter den Namen („3 Anhänger, je 24,90 €. …“), '' bei einem Anhänger
      summeText: function (preis) {
        var n = stueckGesamt();
        return n < 2 ? '' : n + ' Anhänger' + (preis ? ', je ' + preis : '') + '.' + (mehrere() ? ' Jedes Haustier bekommt seinen eigenen Anhänger.' : '');
      },
      korbText: function () { var n = stueckGesamt(); return n > 1 ? n + ' Anhänger in den Warenkorb legen' : 'In den Warenkorb legen'; },
      // Vertragsfelder für EIN Tier (Formular des Themes): Name, _Motiv, _Motiv-ID, _Layout, im Demo-Modus _Demo
      einzelFelder: function () {
        var t = tiere[0], fertig = t.phase === 'fertig';
        return {
          Name: sauberName(nameVon(t)), _Motiv: fertig ? t.motivUrl : '',
          '_Motiv-ID': fertig ? t.id : '', _Layout: fertig ? 'v1' : '', _Demo: DEMO && fertig ? 'ja' : ''
        };
      },
      // Warenkorb-Zeile eines Tiers (eigene Anfrage): Menge = Anzahl, Eigenschaften wie bisher, weitere aus dem Formular
      zeile: function (t, vid, extra) {
        var p = { Name: sauberName(nameVon(t)), _Motiv: t.motivUrl, '_Motiv-ID': t.id, _Layout: 'v1' };
        if (DEMO) p._Demo = 'ja';
        Object.keys(extra).forEach(function (k) { if (!p.hasOwnProperty(k)) p[k] = extra[k]; });
        return { id: vid, quantity: t.menge, properties: p };
      },
      speicherForm: function () {
        var g = eintragZumMerken(tiere[0]);
        if (mehrere()) g.tiere = tiere.map(eintragZumMerken);
        return g;
      },
      // Gespeicherte Form -> Einträge zum Anwenden: {weiteres (false = erstes Tier), name, motiv (ungeprüft), menge}.
      // Leere weitere Einträge fallen weg, höchstens MAX_TIERE, Anzahl 1 bis MAX_STUECK.
      ausSpeicher: function (g) {
        var liste = Array.isArray(g.tiere) && g.tiere.length > 1 ? g.tiere.slice(0, MAX_TIERE) : [{ name: g.name, motiv: g.motiv, menge: g.menge }];
        var aus = [];
        liste.forEach(function (e, i) {
          if (!e || typeof e !== 'object') return;
          if (i > 0 && !e.name && !e.motiv) return;
          aus.push({ weiteres: i > 0, name: e.name, motiv: e.motiv, menge: klemme(parseInt(e.menge, 10) || 1, 1, MAX_STUECK) });
        });
        return aus;
      }
    };
  }

  // ================================================================== Produktseite
  // Mehrere Haustiere (Inhaber 02.10.26): Hat das erste Tier ein Foto, erscheint daneben im gleichen Format ein
  // weiteres Feld „Du hast noch einen Liebling?“ – höchstens MAX_TIERE (5). Jedes Tier = ein eigener Anhänger = eine
  // eigene Warenkorb-Zeile zum vollen Preis, mit eigenem Namen und Motiv. Die Eigenschaften je Zeile bleiben genau wie
  // bisher (Name, _Motiv, _Motiv-ID, _Layout) – Gravur-Station und xTool-Datei brauchen keine Änderung.
  // Anzahl (Inhaber 02.10.26): je Tier 1 bis 10 Stück. Was gewählt ist und alle Regeln dazu: Tier-Auswahl (oben).
  // In den Warenkorb (ein Anhänger über das Formular des Themes, sonst eine eigene Anfrage): Übergabe an den Warenkorb.
  // Hier stehen Bildschirm, Fotos, Zuschnitt, Motiv-Anfragen, Vorschau und die Prüfung vor dem Warenkorb.
  function Personalisierung(root) {
    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) {}
    var API = (cfg.api || '').replace(/\/+$/, '');
    var DEMO = !API || cfg.demo === true;
    var MAX_NAME = cfg.maxName || 12, MAX_VERSUCHE = cfg.maxVersuche || 5;
    var SPEICHER = 'pmg:' + (cfg.produktId || location.pathname);
    var uid = zufallsId().slice(0, 6);
    function limitText() {
      return 'Du hast die maximale Anzahl an Motiv-Erstellungen erreicht. ' +
        (tiere.some(function (t) { return t.phase === 'fertig'; }) ? 'Dein aktuelles Motiv kannst du weiterhin bestellen. ' : '') +
        'Für ein neues Motiv schreib uns gern an kontakt@pfotenmond.de.';
    }
    // Preis je Anhänger für den Hinweis bei mehreren Tieren (aus Liquid: Cent + Währung des Warenkorbs)
    function preisText() {
      var c = Number(cfg.preisCent);
      if (!(c > 0) || c % 1) return '';
      var w = /^[A-Z]{3}$/.test(String(cfg.waehrung || '')) ? cfg.waehrung : 'EUR';
      try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: w }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' ' + w; }
    }
    // Demo-Modus (ohne Server) nie im veröffentlichten Shop: dort bleibt der Warenkorb gesperrt.
    var imLiveTheme = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main' && !Shopify.designMode);
    if (DEMO && imLiveTheme) {
      root.classList.add('pmg'); this.gesperrt = true;
      root.innerHTML = '<p class="pmg-hinweis" role="alert">Die Personalisierung ist gerade in Wartung. Bitte versuche es später noch einmal.</p>';
      return;
    }

    // Ein Tier: phase leer | laeuft | fertig | fehler, laedt (Motiv wird nach Neuladen wiederhergestellt),
    // quelle (Canvas des bestätigten Ausschnitts), zuschnitt {s, tx, ty, B}, ausschnitt (base64 JPEG 1024x1024),
    // motiv {dunkel, hell}, motivUrl, id, auftrag (verwirft veraltete Antworten), menge (Anzahl dieses Anhängers) –
    // dazu seine Kachel und sein Namensfeld mit Anzahl. Die Liste, die Wahl und die Regeln führt die Tier-Auswahl.
    var auswahl = TierAuswahl({ maxTiere: cfg.maxTiere, maxStueck: cfg.maxStueck, demo: DEMO,
                                nameVon: function (t) { return t.nameIn.value; } });
    var tiere = auswahl.tiere, tierNr = 0, MAX_TIERE = auswahl.MAX_TIERE, MAX_STUECK = auswahl.MAX_STUECK;
    var aktiv = auswahl.aktiv, nummer = auswahl.nummer, mehrere = auswahl.mehrere, neuErlaubt = auswahl.neuErlaubt;

    // ---------------------------------------------------------------- Aufbau
    root.classList.add('pmg');
    root.innerHTML = '';
    var datei = el('input', { type: 'file', accept: 'image/jpeg,image/png,image/webp', hidden: true, 'aria-hidden': 'true', tabindex: '-1' });
    var kacheln = el('div', { class: 'pmg-kacheln' });
    // Name beginnt mit dem sichtbaren Text (Sprachsteuerung findet den Knopf über das, was dasteht)
    var neuKachel = el('button', { type: 'button', class: 'pmg-kachel pmg-kachel--neu', 'aria-label': 'Du hast noch einen Liebling? Foto für ein weiteres Haustier hochladen',
                                   html: '<span class="pmg-kachel-plus">' + ICON.plus + '</span><span class="pmg-kachel-neu-text">Du hast noch einen Liebling?</span>' });
    var neuWrap = el('div', { class: 'pmg-kachel-wrap pmg-kachel-wrap--neu' }, [neuKachel]);
    var knopfWaehlen = el('button', { type: 'button', class: 'pmg-knopf pmg-knopf--klein', text: 'Foto wählen' });
    var knopfAnders = el('button', { type: 'button', class: 'pmg-knopf pmg-knopf--klein', text: 'Anderes Foto', hidden: true });
    var knopfAnpassen = el('button', { type: 'button', class: 'pmg-knopf pmg-knopf--klein', text: 'Ausschnitt ändern', hidden: true });
    var uploadHinweis = el('p', { class: 'pmg-klein' });
    // Datenschutz am Upload (SPEC „Kundenfoto“: das Foto dient nur dem Anhänger, R2-Regel löscht fotos/ nach 90 Tagen).
    // Nur aus el()-Bausteinen, Link in neuem Tab (ein entstehendes Motiv geht nicht verloren) und ohne Seitenwechsel-
    // Animation des Themes (js-no-transition).
    var datenschutz = el('p', { class: 'pmg-klein pmg-datenschutz' }, [
      el('span', { text: 'Dein Foto nutzen wir nur für deinen Anhänger und löschen es nach 90 Tagen automatisch. ' }),
      el('a', { href: ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'policies/privacy-policy',
                target: '_blank', rel: 'noopener', class: 'js-no-transition', text: 'Mehr zum Datenschutz' })
    ]);
    var anzahlHinweis = el('p', { class: 'pmg-anzahl', hidden: true });
    var fehlerBox = el('div', { class: 'pmg-fehler', role: 'alert', hidden: true });
    var hinweis = el('div', { class: 'pmg-hinweis', role: 'alert', hidden: true });
    var namenListe = el('div', { class: 'pmg-namen' });

    var miniCanvas = el('canvas', { width: '600', height: '600', class: 'pmg-mini-canvas', role: 'img', 'aria-label': 'Dein Anhänger mit Gravur' });
    var mini = el('div', { class: 'pmg-mini', hidden: true }, [miniCanvas]);
    var knopfVorschau = el('button', { type: 'button', class: 'pmg-knopf pmg-knopf--breit', html: ICON.auge + '<span>Vorschau ansehen</span>' });
    var status = el('p', { class: 'pmg-sr', 'aria-live': 'polite' });
    var demoHinweis = DEMO ? el('p', { class: 'pmg-demo', text: 'Demo-Modus (nur im Entwurf ohne Server sichtbar): Es wird ein Beispielmotiv gezeigt.' }) : null;

    function tierAnlegen() {
      var t = { nr: ++tierNr, phase: 'leer', laedt: false, quelle: null, zuschnitt: null, ausschnitt: null,
                motiv: null, motivUrl: '', id: '', auftrag: 0, menge: 1 };
      t.kachel = el('button', { type: 'button', class: 'pmg-kachel', 'aria-label': 'Foto hochladen' });
      t.kachelX = el('button', { type: 'button', class: 'pmg-kachel-x', 'aria-label': 'Motiv entfernen', hidden: true, html: ICON.papierkorb });
      t.kachelNr = el('span', { class: 'pmg-kachel-nr', 'aria-hidden': 'true', hidden: true });
      t.kachelMenge = el('span', { class: 'pmg-kachel-menge', 'aria-hidden': 'true', hidden: true });
      t.wrap = el('div', { class: 'pmg-kachel-wrap' }, [t.kachel, t.kachelX, t.kachelNr, t.kachelMenge]);
      var nameId = 'pmg-name-' + uid + (t.nr > 1 ? '-' + t.nr : '');
      t.nameIn = el('input', { id: nameId, type: 'text', class: 'pmg-eingabe', maxlength: String(MAX_NAME), autocomplete: 'off',
                               autocapitalize: 'words', spellcheck: 'false', enterkeyhint: 'done',
                               'aria-required': 'true', 'aria-describedby': nameId + '-h' });
      t.zaehler = el('span', { class: 'pmg-zaehler', 'aria-hidden': 'true', text: '0/' + MAX_NAME });
      t.nameHilfe = el('span', { class: 'pmg-sr', id: nameId + '-h', text: 'Pflichtfeld, höchstens ' + MAX_NAME + ' Zeichen.' });
      t.nameFehler = el('p', { class: 'pmg-feldfehler', role: 'alert', hidden: true, id: nameId + '-f' });
      t.nameDaumen = el('canvas', { width: '96', height: '96', class: 'pmg-name-daumen', 'aria-hidden': 'true', hidden: true });
      t.nameTitel = el('label', { class: 'pmg-titel', for: nameId });
      // Anzahl: derselbe Anhänger mehrmals (Knöpfe statt Eingabefeld: keine Tastatur, kein Absenden mit Enter)
      t.mengeMinus = el('button', { type: 'button', class: 'pmg-stueck-knopf', html: ICON.minus });
      t.mengeZahl = el('span', { class: 'pmg-stueck-zahl', 'aria-live': 'polite', 'aria-atomic': 'true', text: '1' });
      t.mengePlus = el('button', { type: 'button', class: 'pmg-stueck-knopf', html: ICON.plus });
      t.mengeFeld = el('div', { class: 'pmg-stueck', hidden: MAX_STUECK < 2 }, [
        el('span', { class: 'pmg-stueck-titel', id: nameId + '-a', text: 'Anzahl' }),
        el('div', { class: 'pmg-stueck-wahl', role: 'group', 'aria-labelledby': nameId + '-a' }, [t.mengeMinus, t.mengeZahl, t.mengePlus])
      ]);
      t.nameFeld = el('div', { class: 'pmg-feld' }, [
        t.nameTitel,
        el('div', { class: 'pmg-eingabe-wrap' }, [t.nameDaumen, t.nameIn, t.zaehler]),
        t.nameHilfe, t.nameFehler, t.mengeFeld
      ]);
      t.kachel.addEventListener('click', function () {
        if (t.phase === 'laeuft' || t.laedt) { aktivSetzen(t); return; }
        if (t.phase === 'fertig') { aktivSetzen(t); grossOeffnen(); return; }
        aktivSetzen(t); dateiWaehlen(t);
      });
      t.kachelX.addEventListener('click', function () { entfernen(t); });
      t.mengeMinus.addEventListener('click', function () { mengeSetzen(t, t.menge - 1); });
      t.mengePlus.addEventListener('click', function () { mengeSetzen(t, t.menge + 1); });
      t.nameIn.addEventListener('input', function () {
        nameZaehlen(t);
        if (!t.nameFehler.hidden) pruefeName(t, false);
        hinweisWeg();
        aktivSetzen(t);
        felderSetzen(); hinweisText(); allesZeichnen(); merken();
      });
      t.nameIn.addEventListener('focus', function () { if (mehrere()) aktivSetzen(t); });
      t.nameIn.addEventListener('blur', function () { if (t.nameIn.value) pruefeName(t, false); });
      t.nameIn.addEventListener('keydown', function (e) {       // Enter würde über UpCart sofort in den Warenkorb legen
        if (e.key === 'Enter') { e.preventDefault(); t.nameIn.blur(); }
      });
      return t;
    }
    auswahl.anhaengen(tierAnlegen());

    var uploadFeld = el('div', { class: 'pmg-feld' }, [
      el('div', { class: 'pmg-titel', html: 'Lade dein Foto hoch <span class="pmg-pflicht" aria-hidden="true">*</span>' }),
      el('div', { class: 'pmg-upload' }, [
        kacheln,
        el('div', { class: 'pmg-knoepfe' }, [knopfWaehlen, knopfAnders, knopfAnpassen]),
        uploadHinweis, datenschutz
      ]),
      fehlerBox, hinweis, datei
    ]);
    root.appendChild(uploadFeld);
    root.appendChild(namenListe);
    root.appendChild(anzahlHinweis);                          // Summe direkt unter Namen und Anzahl
    root.appendChild(mini);
    root.appendChild(knopfVorschau);
    if (demoHinweis) root.appendChild(demoHinweis);
    root.appendChild(status);
    // Übergabe an den Warenkorb: Formular, versteckte Felder (hängen hier am Ende von root), Sperren, Weg, Anfrage
    var korb = WarenkorbUebergabe({ root: root, produktId: cfg.produktId, uid: uid, auswahl: auswahl,
                                    melden: function (text) { meldung(hinweis, text); }, hinweisWeg: hinweisWeg, ansagen: ansage });
    var felderSetzen = korb.felderSetzen;

    // ---------------------------------------------------------------- Name (sauberName: NFC, Leerraum, trimmen – siehe oben)
    function nameFehlerText(v) {
      var n = sauberName(v);
      if (!n) return 'Bitte gib den Namen deines Haustiers ein.';
      if (!NAME_ZEICHEN.test(n) || NAME_UNSICHTBAR.test(n)) return 'Bitte nur Buchstaben, Zahlen, Leerzeichen und die Zeichen - \' & . verwenden.';
      if (Array.from(n).length > Math.min(MAX_NAME, NAME_MAX)) return 'Bitte verwende höchstens ' + Math.min(MAX_NAME, NAME_MAX) + ' Zeichen.';
      return '';
    }
    function nameZaehlen(t) { t.zaehler.textContent = Array.from(t.nameIn.value).length + '/' + MAX_NAME; }
    function pruefeName(t, zeigeLeer) {
      var text = nameFehlerText(t.nameIn.value);
      if (!text || (!zeigeLeer && !sauberName(t.nameIn.value))) {
        t.nameFehler.hidden = true; t.nameIn.removeAttribute('aria-invalid');
        t.nameIn.setAttribute('aria-describedby', t.nameHilfe.id);
        return !text;
      }
      if (t.nameFehler.hidden || t.nameFehler.textContent !== text) meldung(t.nameFehler, text);
      t.nameIn.setAttribute('aria-invalid', 'true'); t.nameIn.setAttribute('aria-describedby', t.nameHilfe.id + ' ' + t.nameFehler.id);
      return false;
    }

    // ---------------------------------------------------------------- Meldungen
    // Text erst nach kurzem Leeren setzen: role="alert" liest ihn dann genau einmal vor.
    function meldung(box, text, knopf) {
      box.innerHTML = ''; box.hidden = false;
      setTimeout(function () {
        box.innerHTML = '';
        box.appendChild(el('span', { text: text }));
        if (knopf) box.appendChild(knopf);
      }, 30);
    }
    // nochmal: das Tier, dessen Motiv „Erneut versuchen“ neu erstellt (sonst kein Knopf)
    // Dieselbe Box zeigt auch „Haustier 2 entfernt.“ mit „Rückgängig“: das ist kein Fehler, also ruhig (neutral) statt rot
    // und für Vorlesehilfen eine höfliche Ansage (role="status") statt einer Unterbrechung (role="alert").
    function ruhigeMeldung(text, knopf) { fehlerBox.classList.add('pmg-fehler--neutral'); fehlerBox.setAttribute('role', 'status'); meldung(fehlerBox, text, knopf); }
    function fehlerZeigen(text, nochmal) {
      fehlerBox.classList.remove('pmg-fehler--neutral');
      fehlerBox.setAttribute('role', 'alert');
      if (!text) { fehlerBox.hidden = true; fehlerBox.innerHTML = ''; return; }
      var b = null;
      if (nochmal) { b = el('button', { type: 'button', class: 'pmg-link', text: 'Erneut versuchen' }); b.addEventListener('click', function () { motivErstellen(nochmal); }); }
      meldung(fehlerBox, text, b);
    }
    function hinweisWeg() { hinweis.hidden = true; hinweis.innerHTML = ''; }
    function ansage(t) { status.textContent = ''; setTimeout(function () { status.textContent = t; }, 30); }
    // Entwurf/Vorschau: großzügiges Limit, damit der Shop-Inhaber viele Fotos testen kann.
    // Inhaber 01.10.26: kein Limit mehr pro Besuch (stoert beim Skalieren). Der Zaehler bleibt nur zur Info.
    function limitErreicht() { return false; }

    // ---------------------------------------------------------------- Kacheln, Namensfelder, Knöpfe
    // Kinder genau in dieser Reihenfolge – nur neu einhängen, wenn sich etwas geändert hat (sonst bleibt der Fokus)
    function reihe(box, kinder) {
      var ist = Array.prototype.slice.call(box.children);
      if (ist.length === kinder.length && kinder.every(function (k, i) { return ist[i] === k; })) return;
      ist.forEach(function (k) { if (kinder.indexOf(k) < 0) box.removeChild(k); });
      kinder.forEach(function (k) { box.appendChild(k); });
    }
    // Bei mehreren Tieren heißt jedes überall gleich: „Haustier 2“ (Kachel, Meldungen, Ansagen, große Ansicht)
    function motivVon(t) { return mehrere() ? 'Das Motiv für Haustier ' + nummer(t) : 'Dein Motiv'; }
    function hinweisText() {
      var a = aktiv(), wer = motivVon(a);
      uploadHinweis.textContent = a.laedt ? wer + ' wird geladen…'
        : a.phase === 'laeuft' ? wer + ' wird gerade erstellt. Das dauert meist 10 bis 20 Sekunden.'
        : a.phase === 'fertig' ? (sauberName(a.nameIn.value) ? wer + ' ist fertig.' : wer + ' ist fertig. Gib jetzt noch den Namen ein.')
        : 'Ein gut erkennbares Foto vom Kopf deines Tieres. Daraus entsteht dein persönliches Motiv.';
    }
    function kachelZeichnen(t) {
      var n = nummer(t), viele = mehrere();
      t.kachel.innerHTML = ''; t.kachel.className = 'pmg-kachel';
      if (viele && t === aktiv()) t.kachel.classList.add('pmg-kachel--aktiv');
      if (viele) t.kachel.classList.add('pmg-kachel--nr');   // Fortschrittsbalken beginnt rechts neben der Nummer
      t.kachelX.hidden = true;
      t.kachelNr.hidden = !viele; t.kachelNr.textContent = String(n);
      if (t.laedt || t.phase === 'laeuft') {
        t.kachel.classList.add('pmg-kachel--laeuft');
        t.kachel.innerHTML = (t.laedt ? '' : '<span class="pmg-balken"><i></i></span>') +
          '<span class="pmg-kachel-text">' + (t.laedt ? 'Motiv wird geladen…' : 'Foto wird analysiert…') + '</span>' +
          '<span class="pmg-pfoten" aria-hidden="true">' + ICON.pfote + ICON.pfote + ICON.pfote + '</span>';
        t.kachel.setAttribute('aria-label', (viele ? 'Motiv für Haustier ' + n : 'Motiv') + (t.laedt ? ' wird geladen' : ' wird erstellt'));
      } else if (t.phase === 'fertig') {
        t.kachel.classList.add('pmg-kachel--fertig');
        var c = el('canvas', { width: '360', height: '360', class: 'pmg-kachel-bild', 'aria-hidden': 'true' });
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, 360, 360);
        if (t.motiv) {                                    // Feld ist nicht ganz quadratisch: ohne Verzerrung einpassen
          var mk = t.motiv.dunkel, sk = Math.min(332 / mk.width, 332 / mk.height);
          x.drawImage(mk, (360 - mk.width * sk) / 2, (360 - mk.height * sk) / 2, mk.width * sk, mk.height * sk);
        }
        t.kachel.appendChild(c);
        t.kachel.setAttribute('aria-label', viele ? 'Haustier ' + n + ': Motiv groß ansehen' : 'Motiv groß ansehen');
        t.kachelX.hidden = limitErreicht();
      } else {
        t.kachel.innerHTML = '<span class="pmg-kachel-plus">' + ICON.plus + '</span>';
        t.kachel.setAttribute('aria-label', viele ? 'Foto für Haustier ' + n + ' hochladen' : 'Foto hochladen');
      }
      // Mehrere Tiere: jedes lässt sich mit dem Papierkorb entfernen (nur nicht, solange sein Motiv entsteht)
      if (viele && !(t.laedt || t.phase === 'laeuft')) t.kachelX.hidden = false;
      t.kachelX.setAttribute('aria-label', viele ? 'Haustier ' + n + ' entfernen' : 'Motiv entfernen');
    }
    function knopfText(k, text) {
      var n = mehrere() ? ' (Nr. ' + nummer(aktiv()) + ')' : '';
      if (k.textContent !== text + n) k.textContent = text + n;
    }
    function kachelnZeichnen() {
      hinweisWeg();
      var soll = tiere.map(function (t) { return t.wrap; });
      if (neuErlaubt()) soll.push(neuWrap);
      reihe(kacheln, soll);
      reihe(namenListe, tiere.map(function (t) { return t.nameFeld; }));
      tiere.forEach(function (t, i) {
        var titel = (mehrere() ? 'Name deines ' + (i + 1) + '. Haustiers' : 'Name deines Haustiers') + ' <span class="pmg-pflicht" aria-hidden="true">*</span>';
        if (t.nameTitel.innerHTML !== titel) t.nameTitel.innerHTML = titel;
        t.nameDaumen.hidden = !mehrere();
        kachelZeichnen(t);
      });
      var a = aktiv(), fertig = a.phase === 'fertig' && !a.laedt, beschaeftigt = a.phase === 'laeuft' || a.laedt;
      var gesperrt = limitErreicht();
      knopfWaehlen.hidden = fertig || beschaeftigt;
      knopfAnders.hidden = !fertig || gesperrt;
      knopfAnpassen.hidden = !a.quelle || beschaeftigt || a.phase === 'leer' || gesperrt;
      knopfText(knopfWaehlen, 'Foto wählen'); knopfText(knopfAnders, 'Anderes Foto'); knopfText(knopfAnpassen, 'Ausschnitt ändern');
      mengeZeichnen();
      hinweisText();
    }
    // Anzahl je Tier: Zahl, Knöpfe (am Rand nur gesperrt, der Fokus bleibt), „2ד an der Kachel, Summe aller Anhänger
    function mengeZeichnen() {
      var viele = mehrere();
      tiere.forEach(function (t, i) {
        var wer = viele ? ' für Haustier ' + (i + 1) : '';
        if (t.mengeZahl.textContent !== String(t.menge)) t.mengeZahl.textContent = String(t.menge);
        t.mengeMinus.setAttribute('aria-disabled', t.menge <= 1 ? 'true' : 'false');
        t.mengePlus.setAttribute('aria-disabled', t.menge >= MAX_STUECK ? 'true' : 'false');
        t.mengeMinus.setAttribute('aria-label', 'Einen Anhänger weniger' + wer);
        t.mengePlus.setAttribute('aria-label', 'Einen Anhänger mehr' + wer);
        t.kachelMenge.hidden = t.menge < 2;
        t.kachelMenge.textContent = t.menge < 2 ? '' : t.menge + '×';
      });
      var summe = auswahl.summeText(preisText());
      anzahlHinweis.hidden = !summe;
      anzahlHinweis.textContent = summe;
    }
    function mengeSetzen(t, n) {
      if (!auswahl.mengeSetzen(t, n)) return;
      if (mehrere()) aktivSetzen(t);                     // wie beim Namensfeld: die Vorschau zeigt diesen Anhänger
      hinweisWeg(); mengeZeichnen(); merken();
    }
    function aktivSetzen(t) {
      if (!auswahl.waehlen(t)) return;
      kachelnZeichnen(); allesZeichnen();
    }

    // ---------------------------------------------------------------- Vorschau (Galerie, Daumen, mobil, groß)
    var galerie = null, galerieCanvas = null, daumenCanvas = null;
    function galerieFinden() {
      if (galerie && document.contains(galerie)) return;
      var sek = root.closest('.product-section') || document;
      var slide = sek.querySelector('.product-main-slide[data-index="0"] .product-image-main') || sek.querySelector('[data-product-image-main]');
      if (!slide) return;
      galerieCanvas = el('canvas', { width: '1080', height: '1080', role: 'img', 'aria-label': 'Dein Anhänger mit Gravur' });
      galerie = el('div', { class: 'pmg-galerie', hidden: true, 'data-pm-geprueft': '1' }, [galerieCanvas]);
      slide.appendChild(galerie);
      // Daumen 0: nur in die quadratische .image-wrap, nie über die ganze Leiste
      var daumen = sek.querySelector('.product__thumb-item[data-index="0"] .image-wrap');
      if (daumen) {
        daumen.classList.add('pmg-daumen-wrap');
        daumenCanvas = el('canvas', { width: '240', height: '240', class: 'pmg-daumen', hidden: true, 'aria-hidden': 'true' });
        daumen.appendChild(daumenCanvas);
      }
    }
    function zeigeSlideNull() {
      try {
        var sl = (root.closest('.product-section') || document).querySelector('[data-product-photos]');
        var fl = sl && window.Flickity && window.Flickity.data(sl);
        if (fl && fl.selectedIndex !== 0) fl.select(0);
      } catch (e) {}
    }
    // kleines Motiv im Namensfeld (nur bei mehreren Tieren): welcher Name gehört zu welchem Bild
    function namenDaumenZeichnen(t) {
      var x = t.nameDaumen.getContext('2d');
      x.fillStyle = '#fff'; x.fillRect(0, 0, 96, 96);
      if (t.motiv) {
        var mk = t.motiv.dunkel, s = Math.min(88 / mk.width, 88 / mk.height);
        x.drawImage(mk, (96 - mk.width * s) / 2, (96 - mk.height * s) / 2, mk.width * s, mk.height * s);
      } else {
        x.fillStyle = '#b4b0a8'; x.font = '600 36px ' + SCHRIFT; x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText(String(nummer(t)), 48, 50);
      }
    }
    // Bei mehreren Tieren bleibt die Vorschau stehen (leerer Anhänger mit Platzhalter), solange das gewählte Tier noch
    // kein Motiv und keinen Namen hat; sonst käme kurz das Produktfoto zurück.
    function allesZeichnen() {
      var a = aktiv(), hatEtwas = !!(a.motiv || sauberName(a.nameIn.value) || mehrere());
      galerieFinden();
      if (galerie) {
        galerie.hidden = !hatEtwas;
        if (hatEtwas) zeichneAnhaenger(galerieCanvas, { motiv: a.motiv, name: a.nameIn.value, art: 'galerie' });
      }
      if (daumenCanvas) {
        daumenCanvas.hidden = !hatEtwas;
        if (hatEtwas) zeichneAnhaenger(daumenCanvas, { motiv: a.motiv, name: a.nameIn.value, art: 'thumb' });
      }
      mini.hidden = !hatEtwas;
      if (hatEtwas) zeichneAnhaenger(miniCanvas, { motiv: a.motiv, name: a.nameIn.value, art: 'galerie' });
      if (!grossModal.hidden) grossZeichnen();
      if (mehrere()) tiere.forEach(namenDaumenZeichnen);
    }

    // ---------------------------------------------------------------- Modale Fenster (gemeinsam)
    var offenesModal = null, letzterFokus = null;
    function modalOeffnen(m, fokus) {
      letzterFokus = document.activeElement; offenesModal = m;
      m.hidden = false;
      document.documentElement.classList.add('pmg-modal-offen');
      void m.offsetWidth;                                     // Stil anwenden, damit das Einblenden sichtbar ist
      m.classList.add('pmg-modal--sichtbar');
      naechsterFrame(function () { (fokus || m.querySelector('button')).focus({ preventScroll: true }); });
    }
    function modalSchliessen(m) {
      m.classList.remove('pmg-modal--sichtbar'); m.hidden = true; offenesModal = null;
      document.documentElement.classList.remove('pmg-modal-offen');
      if (letzterFokus && letzterFokus.focus && document.contains(letzterFokus)) letzterFokus.focus({ preventScroll: true });
    }
    document.addEventListener('keydown', function (e) {
      if (!offenesModal) return;
      if (e.key === 'Escape') { e.preventDefault(); offenesModal._abbrechen(); return; }
      if (e.key === 'Tab') {                                  // Fokus im Fenster halten
        var f = Array.prototype.filter.call(offenesModal.querySelectorAll('button, input, [tabindex="0"]'), function (n) { return !n.disabled && n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });

    // ---------------------------------------------------------------- Große Ansicht + Warenkorb
    var grossCanvas = el('canvas', { width: '1080', height: '1080', class: 'pmg-gross-canvas', role: 'img', 'aria-label': 'Dein Anhänger mit Gravur, groß' });
    var grossModal = el('div', { class: 'pmg-modal', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Dein Anhänger', hidden: true });
    var grossZu = el('button', { type: 'button', class: 'pmg-modal-x', 'aria-label': 'Schließen', html: ICON.x });
    var grossOk = el('button', { type: 'button', class: 'pmg-knopf', text: 'Schließen' });
    var grossKorbText = el('span', { text: 'In den Warenkorb legen' });
    var grossKorb = el('button', { type: 'button', class: 'pmg-knopf pmg-knopf--haupt pmg-knopf--korb' }, [el('span', { class: 'pmg-korb-icon', html: ICON.korb }), grossKorbText]);
    // Bei mehreren Tieren: Auswahl der Anhänger unter dem großen Bild
    var grossAuswahl = el('div', { class: 'pmg-gross-auswahl', role: 'group', 'aria-label': 'Haustier wählen', hidden: true });
    // pmg-modal-karte--mehrere (bei mehreren Tieren): eigene Maße, damit Auswahl und Warenkorb-Knopf sichtbar bleiben
    var grossKarte = el('div', { class: 'pmg-modal-karte pmg-modal-karte--vorschau' }, [
      grossZu, el('div', { class: 'pmg-gross-buehne' }, [grossCanvas]), grossAuswahl,
      el('p', { class: 'pmg-klein pmg-gross-text', text: 'Graviert bei uns in Köln.' }),
      el('div', { class: 'pmg-modal-fuss' }, [grossOk, grossKorb])
    ]);
    grossModal.appendChild(grossKarte);
    grossModal._abbrechen = function () { modalSchliessen(grossModal); };
    grossZu.addEventListener('click', grossModal._abbrechen);
    grossOk.addEventListener('click', grossModal._abbrechen);
    grossModal.addEventListener('click', function (e) { if (e.target === grossModal) grossModal._abbrechen(); });
    document.body.appendChild(grossModal);
    function grossZeichnen() {
      var a = aktiv();
      zeichneAnhaenger(grossCanvas, { motiv: a.motiv, name: a.nameIn.value, art: 'galerie' });
      grossAuswahl.hidden = !mehrere();
      grossKarte.classList.toggle('pmg-modal-karte--mehrere', mehrere());
      if (!mehrere()) { if (grossAuswahl.children.length) grossAuswahl.innerHTML = ''; return; }
      var fokusIdx = -1;
      Array.prototype.forEach.call(grossAuswahl.children, function (b, i) { if (b === document.activeElement) fokusIdx = i; });
      grossAuswahl.innerHTML = '';
      tiere.forEach(function (t, i) {
        var c = el('canvas', { width: '160', height: '160', 'aria-hidden': 'true' });
        zeichneAnhaenger(c, { motiv: t.motiv, name: t.nameIn.value, art: 'thumb', platzhalter: false });
        var b = el('button', { type: 'button', class: 'pmg-gross-wahl', 'aria-label': 'Haustier ' + (i + 1) + ' ansehen',
                               'aria-pressed': t === a ? 'true' : 'false' }, [c]);
        b.addEventListener('click', function () { aktivSetzen(t); });
        grossAuswahl.appendChild(b);
      });
      if (fokusIdx >= 0 && grossAuswahl.children[fokusIdx]) grossAuswahl.children[fokusIdx].focus({ preventScroll: true });
    }
    function grossOeffnen() {
      grossZeichnen();
      korbKnopfAktualisieren();
      modalOeffnen(grossModal, grossKorb.disabled ? grossOk : grossKorb);
    }

    // Der "In den Warenkorb"-Knopf des Themes (Übergabe): über ihn laufen UpCart, Theme und unsere Prüfung
    // (pruefeVorWarenkorb) genau wie bei einem normalen Klick.
    function korbKnopfAktualisieren() {
      var k = korb.themeKnopf();
      var aus = !k || k.disabled || k.getAttribute('aria-disabled') === 'true';
      grossKorb.disabled = aus;
      grossKorbText.textContent = aus ? 'Ausverkauft' : auswahl.korbText();
    }
    grossKorb.addEventListener('click', function () {
      var k = korb.themeKnopf();
      if (!k || k.disabled) { korbKnopfAktualisieren(); return; }
      letzterFokus = null;                              // Fokus nicht zurück auf "Vorschau ansehen" setzen
      korb.ausFenster();
      modalSchliessen(grossModal);
      // erst nach dem Schließen (Scroll-Sperre aufgehoben), damit UpCart seinen Warenkorb normal öffnet
      setTimeout(function () { k.click(); }, 30);
    });
    knopfVorschau.addEventListener('click', grossOeffnen);

    // ---------------------------------------------------------------- Zuschneiden
    var cropModal = el('div', { class: 'pmg-modal', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'pmg-ct-' + uid, hidden: true });
    var cropCanvas = el('canvas', { class: 'pmg-crop-canvas', tabindex: '0', 'aria-label': 'Foto verschieben mit den Pfeiltasten, zoomen mit Plus und Minus' });
    var cropRahmen = el('div', { class: 'pmg-crop-rahmen', 'aria-hidden': 'true' });
    var zoom = el('input', { type: 'range', min: '0', max: '1000', value: '0', class: 'pmg-zoom', 'aria-label': 'Zoom' });
    var zMinus = el('button', { type: 'button', class: 'pmg-rund', 'aria-label': 'Verkleinern', html: ICON.minus });
    var zPlus = el('button', { type: 'button', class: 'pmg-rund', 'aria-label': 'Vergrößern', html: ICON.plus });
    var cropZu = el('button', { type: 'button', class: 'pmg-modal-x', 'aria-label': 'Abbrechen', html: ICON.x });
    var cropAbbr = el('button', { type: 'button', class: 'pmg-knopf', text: 'Abbrechen' });
    var cropOk = el('button', { type: 'button', class: 'pmg-knopf pmg-knopf--haupt', text: 'Ausschnitt übernehmen' });
    cropModal.appendChild(el('div', { class: 'pmg-modal-karte' }, [
      cropZu,
      el('h3', { class: 'pmg-modal-titel', id: 'pmg-ct-' + uid, text: 'Ausschnitt wählen' }),
      el('p', { class: 'pmg-klein', text: 'Schieb den Kopf deines Tieres mittig in den Rahmen. Die Ohrenspitzen sollten drin sein.' }),
      el('div', { class: 'pmg-crop-buehne' }, [cropCanvas, cropRahmen]),
      el('div', { class: 'pmg-zoom-zeile' }, [zMinus, zoom, zPlus]),
      el('div', { class: 'pmg-modal-fuss' }, [cropAbbr, cropOk])
    ]));
    document.body.appendChild(cropModal);

    // aktQ = Foto, das gerade zugeschnitten wird; cropZiel = Tier, für das (oder 'neu': ein weiteres Tier).
    // Erst "Übernehmen" macht es zu dessen quelle.
    var aktQ = null, cropZiel = null;
    var cr = { s: 1, min: 1, max: 5, tx: 0, ty: 0, B: 0, F: 0, fx: 0, fy: 0, dpr: 1, zeiger: new Map(), pinch: null };
    function cropMasse() {
      var B = Math.min(cropCanvas.clientWidth, cropCanvas.clientHeight) || 320;
      cr.dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      cropCanvas.width = Math.round(B * cr.dpr); cropCanvas.height = Math.round(B * cr.dpr);
      cr.B = B; cr.F = B * 0.8; cr.fx = (B - cr.F) / 2; cr.fy = (B - cr.F) / 2;
    }
    function cropBegrenzen() {
      if (!aktQ) return;
      cr.s = klemme(cr.s, cr.min, cr.max);
      var w = aktQ.width * cr.s, h = aktQ.height * cr.s;
      cr.tx = klemme(cr.tx, cr.fx + cr.F - w, cr.fx);
      cr.ty = klemme(cr.ty, cr.fy + cr.F - h, cr.fy);
    }
    function cropZeichnen() {
      if (!aktQ) return;
      var x = cropCanvas.getContext('2d');
      x.setTransform(cr.dpr, 0, 0, cr.dpr, 0, 0);
      x.fillStyle = '#1c1d1d'; x.fillRect(0, 0, cr.B, cr.B);
      x.imageSmoothingQuality = 'high';
      x.drawImage(aktQ, cr.tx, cr.ty, aktQ.width * cr.s, aktQ.height * cr.s);
      zoom.value = String(Math.round(1000 * Math.log(cr.s / cr.min) / Math.log(cr.max / cr.min)));
    }
    function zoomUm(faktor, px, py) {
      var alt = cr.s, neu = klemme(alt * faktor, cr.min, cr.max);
      if (px == null) { px = cr.B / 2; py = cr.B / 2; }
      cr.tx = px - (px - cr.tx) * (neu / alt); cr.ty = py - (py - cr.ty) * (neu / alt); cr.s = neu;
      cropBegrenzen(); cropZeichnen();
    }
    function cropStart(q, alterZuschnitt, ziel) {
      aktQ = q; cropZiel = ziel;
      modalOeffnen(cropModal, cropOk);
      naechsterFrame(function () {
        cropMasse();
        cr.min = cr.F / Math.min(q.width, q.height); cr.max = cr.min * 5;
        if (!alterZuschnitt) {
          cr.s = cr.min * 1.08;
          cr.tx = cr.B / 2 - q.width * cr.s / 2; cr.ty = cr.B / 2 - q.height * cr.s * 0.46;
        } else {                                                     // bestätigten Ausschnitt wiederherstellen
          var f = cr.B / alterZuschnitt.B;
          cr.s = alterZuschnitt.s * f; cr.tx = alterZuschnitt.tx * f; cr.ty = alterZuschnitt.ty * f;
        }
        cropBegrenzen(); cropZeichnen(); cropCanvas.focus({ preventScroll: true });
      });
    }
    window.addEventListener('resize', function () {
      if (cropModal.hidden || !aktQ) return;
      var altB = cr.B, altS = cr.s, altTx = cr.tx, altTy = cr.ty; cropMasse();
      var f = cr.B / (altB || cr.B); cr.min = cr.F / Math.min(aktQ.width, aktQ.height); cr.max = cr.min * 5;
      cr.s = altS * f; cr.tx = altTx * f; cr.ty = altTy * f; cropBegrenzen(); cropZeichnen();
    });
    cropCanvas.addEventListener('pointerdown', function (e) {
      try { cropCanvas.setPointerCapture(e.pointerId); } catch (err) {}
      cr.zeiger.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (cr.zeiger.size === 2) {
        var p = Array.from(cr.zeiger.values());
        cr.pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s: cr.s };
      }
    });
    cropCanvas.addEventListener('pointermove', function (e) {
      if (!cr.zeiger.has(e.pointerId)) return;
      var alt = cr.zeiger.get(e.pointerId), r = cropCanvas.getBoundingClientRect();
      cr.zeiger.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (cr.zeiger.size === 1) { cr.tx += e.clientX - alt.x; cr.ty += e.clientY - alt.y; cropBegrenzen(); cropZeichnen(); }
      else if (cr.zeiger.size === 2 && cr.pinch) {
        var p = Array.from(cr.zeiger.values()), d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        var mx = (p[0].x + p[1].x) / 2 - r.left, my = (p[0].y + p[1].y) / 2 - r.top;
        zoomUm((cr.pinch.s * d / cr.pinch.d) / cr.s, mx, my);
      }
    });
    function zeigerEnde(e) { cr.zeiger.delete(e.pointerId); if (cr.zeiger.size < 2) cr.pinch = null; }
    cropCanvas.addEventListener('pointerup', zeigerEnde);
    cropCanvas.addEventListener('pointercancel', zeigerEnde);
    cropCanvas.addEventListener('wheel', function (e) {
      e.preventDefault(); var r = cropCanvas.getBoundingClientRect();
      zoomUm(Math.exp(-e.deltaY * 0.0015), e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });
    cropCanvas.addEventListener('keydown', function (e) {
      var m = { ArrowLeft: [8, 0], ArrowRight: [-8, 0], ArrowUp: [0, 8], ArrowDown: [0, -8] }[e.key];
      if (m) { e.preventDefault(); cr.tx += m[0]; cr.ty += m[1]; cropBegrenzen(); cropZeichnen(); }
      if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomUm(1.1); }
      if (e.key === '-') { e.preventDefault(); zoomUm(1 / 1.1); }
    });
    zoom.addEventListener('input', function () {
      var ziel = cr.min * Math.pow(cr.max / cr.min, Number(zoom.value) / 1000);
      zoomUm(ziel / cr.s);
    });
    zMinus.addEventListener('click', function () { zoomUm(1 / 1.15); });
    zPlus.addEventListener('click', function () { zoomUm(1.15); });
    cropModal._abbrechen = function () { aktQ = null; cropZiel = null; modalSchliessen(cropModal); };
    cropZu.addEventListener('click', cropModal._abbrechen);
    cropAbbr.addEventListener('click', cropModal._abbrechen);
    function neuesTierAnhaengen() {
      if (auswahl.voll()) { meldung(hinweis, 'Du kannst höchstens ' + MAX_TIERE + ' Haustiere auf einmal hinzufügen.'); return null; }
      var t = tierAnlegen();
      auswahl.neuAnhaengen(t);
      return t;
    }
    cropOk.addEventListener('click', function () {
      if (!aktQ) return;
      if (limitErreicht()) { cropModal._abbrechen(); meldung(hinweis, limitText()); return; }
      var neu = cropZiel === 'neu';
      var t = neu ? neuesTierAnhaengen() : cropZiel;
      if (!t || tiere.indexOf(t) < 0) { cropModal._abbrechen(); return; }
      var n = 1024, c = document.createElement('canvas'); c.width = c.height = n;
      var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, n, n); x.imageSmoothingQuality = 'high';
      var sx = (cr.fx - cr.tx) / cr.s, sy = (cr.fy - cr.ty) / cr.s, sw = cr.F / cr.s;
      x.drawImage(aktQ, sx, sy, sw, sw, 0, 0, n, n);
      t.quelle = aktQ; aktQ = null; cropZiel = null;
      t.zuschnitt = { s: cr.s, tx: cr.tx, ty: cr.ty, B: cr.B };
      t.ausschnitt = c.toDataURL('image/jpeg', 0.9).split(',')[1];
      modalSchliessen(cropModal);
      auswahl.waehlen(t);
      motivErstellen(t);
      if (neu) { allesZeichnen(); t.kachel.focus({ preventScroll: true }); }
    });

    // ---------------------------------------------------------------- Foto wählen
    var dateiZiel = null;
    function dateiWaehlen(ziel) {
      // Ausverkauft sperrt nur im veröffentlichten Shop – im Entwurf/in der Vorschau bleibt das Motiv testbar.
      if (cfg.ausverkauft && !DEMO && imLiveTheme) { meldung(hinweis, 'Dieser Anhänger ist gerade ausverkauft. Sobald er wieder da ist, kannst du hier dein Motiv erstellen.'); return; }
      if (limitErreicht()) { meldung(hinweis, limitText()); return; }
      dateiZiel = ziel;
      datei.value = ''; datei.click();
    }
    knopfWaehlen.addEventListener('click', function () { dateiWaehlen(aktiv()); });
    knopfAnders.addEventListener('click', function () { dateiWaehlen(aktiv()); });
    knopfAnpassen.addEventListener('click', function () {
      if (limitErreicht()) { meldung(hinweis, limitText()); return; }
      var a = aktiv();
      if (a.quelle) cropStart(a.quelle, a.zuschnitt, a);
    });
    neuKachel.addEventListener('click', function () { if (neuErlaubt()) dateiWaehlen('neu'); });
    datei.addEventListener('change', function () {
      var f = datei.files && datei.files[0];
      if (!f) return;
      var ziel = dateiZiel || aktiv();
      fehlerZeigen('');
      if (f.size > 25 * 1024 * 1024) { fehlerZeigen('Das Foto ist größer als 25 MB. Bitte wähle ein kleineres Foto.'); return; }
      var url = URL.createObjectURL(f);
      bildLaden(url, false).then(function (img) {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth, h = img.naturalHeight;
        if (Math.min(w, h) < 300) { fehlerZeigen('Das Foto ist sehr klein. Bitte nimm ein Foto, das an der kürzeren Seite mindestens 300 Pixel hat.'); return; }
        var s = Math.min(1, 2400 / Math.max(w, h)), c = document.createElement('canvas');
        c.width = Math.round(w * s); c.height = Math.round(h * s);
        var x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(img, 0, 0, c.width, c.height);
        cropStart(c, null, ziel);
      }).catch(function () {
        URL.revokeObjectURL(url);
        fehlerZeigen('Dieses Bildformat kann dein Browser leider nicht öffnen. Bitte wähle ein JPG- oder PNG-Foto. Bei iPhone-Fotos hilft ein Screenshot des Bildes.');
      });
    });

    // ---------------------------------------------------------------- Entfernen mit "Rückgängig"
    var rueckTimer = null;
    function entfernen(t) {
      if (tiere.indexOf(t) < 0) return;
      if (!mehrere()) { entfernenMitRueckgaengig(t); return; }
      // Mehrere Tiere: das Tier fällt ganz weg (mit Kachel und Namensfeld), „Rückgängig“ setzt es zurück an seinen Platz
      var idx = auswahl.entfernen(t);
      fehlerZeigen(''); kachelnZeichnen(); felderSetzen(); allesZeichnen(); merken();
      var b = el('button', { type: 'button', class: 'pmg-link', text: 'Rückgängig' });
      b.addEventListener('click', function () {
        clearTimeout(rueckTimer);
        fehlerZeigen('');
        if (!auswahl.zurueckholen(t, idx)) return;
        kachelnZeichnen(); felderSetzen(); allesZeichnen(); merken();
        t.kachel.focus({ preventScroll: true });
      });
      ruhigeMeldung('Haustier ' + (idx + 1) + ' entfernt.', b);
      clearTimeout(rueckTimer);
      rueckTimer = setTimeout(function () {
        if (fehlerBox.contains(b) || fehlerBox.textContent.indexOf('Haustier ' + (idx + 1) + ' entfernt') === 0) fehlerZeigen('');
      }, 8000);
      aktiv().kachel.focus({ preventScroll: true });
    }
    function entfernenMitRueckgaengig(t) {
      var alt = { phase: t.phase, motiv: t.motiv, motivUrl: t.motivUrl, id: t.id,
                  quelle: t.quelle, zuschnitt: t.zuschnitt, ausschnitt: t.ausschnitt };
      zuruecksetzen(t, true);
      var b = el('button', { type: 'button', class: 'pmg-link', text: 'Rückgängig' });
      b.addEventListener('click', function () {
        clearTimeout(rueckTimer);
        if (tiere.indexOf(t) < 0) return;
        t.auftrag++; Object.keys(alt).forEach(function (k) { t[k] = alt[k]; });
        fehlerZeigen(''); kachelnZeichnen(); felderSetzen(); allesZeichnen(); merken();
        t.kachel.focus({ preventScroll: true });
      });
      ruhigeMeldung('Motiv entfernt.', b);
      clearTimeout(rueckTimer);
      rueckTimer = setTimeout(function () {
        if (t.phase !== 'leer') return;
        if (fehlerBox.contains(b) || fehlerBox.textContent.indexOf('Motiv entfernt') === 0) fehlerZeigen('');
        merken();
      }, 8000);
      t.kachel.focus({ preventScroll: true });
    }

    // ---------------------------------------------------------------- Motiv erstellen
    function versuche() { var v = speicherLesen(SPEICHER + ':versuche'); return typeof v === 'number' ? v : 0; }
    // Fokus nur dann ins Namensfeld, wenn der Kunde gerade nirgends tippt (mehrere Motive entstehen gleichzeitig)
    function tipptGerade() {
      var a = document.activeElement;
      return !!(a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT') && a.type !== 'file');
    }
    function motivErstellen(t) {
      if (!t || !t.ausschnitt || tiere.indexOf(t) < 0) return;
      if (limitErreicht()) {
        if (t.phase !== 'fertig') { t.phase = 'fehler'; kachelnZeichnen(); felderSetzen(); allesZeichnen(); }
        fehlerZeigen(limitText());
        return;
      }
      var auftrag = ++t.auftrag;
      t.laedt = false; t.phase = 'laeuft'; t.motiv = null; t.motivUrl = t.id = '';
      fehlerZeigen(''); kachelnZeichnen(); felderSetzen(); allesZeichnen(); ansage(motivVon(t) + ' wird erstellt.');
      balkenStarten(t, auftrag);
      var anfrage = DEMO ? demoMotiv() : serverMotiv(t);
      anfrage.then(function (erg) {
        if (auftrag !== t.auftrag) return;
        return bildLaden(erg.src, !!erg.cors).then(function (bild) {
          if (auftrag !== t.auftrag) return;
          t.motiv = gravurEbenen(bild);
          t.motivUrl = erg.motivUrl; t.id = erg.id;
          t.phase = 'fertig';
          if (!DEMO) speicherSchreiben(SPEICHER + ':versuche', versuche() + 1);
          kachelnZeichnen(); felderSetzen(); allesZeichnen(); merken(); zeigeSlideNull();
          vorschauUrl(t.motivUrl, nameKappen(sauberName(t.nameIn.value)));   // Warenkorb-Bild vorbereiten
          ansage(motivVon(t) + ' ist fertig.');
          if (!sauberName(t.nameIn.value) && (!mehrere() || !tipptGerade())) t.nameIn.focus({ preventScroll: true });
        });
      }).catch(function (err) {
        if (auftrag !== t.auftrag) return;
        t.phase = 'fehler'; kachelnZeichnen(); felderSetzen(); allesZeichnen();
        var text = (err && err.kundenText) || 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
        fehlerZeigen((mehrere() ? 'Haustier ' + nummer(t) + ': ' : '') + text, !!t.ausschnitt && !limitErreicht() ? t : null);
      });
    }
    function demoMotiv() {
      return new Promise(function (ok, fehl) {
        if (!cfg.demoMotiv) { fehl({ kundenText: 'Das Beispielmotiv fehlt in der Einstellung.' }); return; }
        var url = new URL(cfg.demoMotiv, location.href).href;
        setTimeout(function () { ok({ src: url, cors: true, motivUrl: url, id: 'demo-' + zufallsId().slice(0, 8) }); }, 2200);
      });
    }
    // XMLHttpRequest statt fetch: die fetch-Hüllen anderer Skripte (Klaviyo) bleiben unberührt.
    function serverMotiv(t) {
      return new Promise(function (ok, fehl) {
        var sitzung = speicherLesen(SPEICHER + ':sitzung');
        if (!sitzung) { sitzung = zufallsId(); speicherSchreiben(SPEICHER + ':sitzung', sitzung); }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', API + '/v1/motiv', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.timeout = 100000;
        function fehler(text, code) { var e = new Error(code || 'fehler'); e.kundenText = text; fehl(e); }
        xhr.onload = function () {
          var j = null; try { j = JSON.parse(xhr.responseText); } catch (e) {}
          if (xhr.status >= 200 && xhr.status < 300 && j && j.motiv && j.motiv.daten && j.motiv.url) {
            // Nur ein Motiv von unserem Server mit gültiger ID – sonst wie ein Fehler bei der Erstellung
            if (!motivUrlGueltig(j.motiv.url, j.id, API)) {
              fehler('Beim Erstellen deines Motivs ist etwas schiefgelaufen. Bitte versuche es gleich noch einmal.', 'ki_fehler');
              return;
            }
            var mime = /^image\/(png|jpeg)$/.test(j.motiv.mime) ? j.motiv.mime : 'image/jpeg';
            ok({ src: 'data:' + mime + ';base64,' + j.motiv.daten, cors: false,
                 motivUrl: bildBasis(API) + j.id + '/motiv', id: j.id });   // URL selbst gebaut
            return;
          }
          fehler((j && j.text) || (xhr.status === 429 ? 'Gerade ist bei uns sehr viel los. Bitte versuche es in einer Minute noch einmal.' : ''), j && j.fehler);
        };
        xhr.ontimeout = function () { fehler('Die Erstellung dauert gerade ungewöhnlich lange. Bitte versuche es noch einmal.', 'zeit'); };
        xhr.onerror = function () { fehler('Das hat gerade nicht geklappt. Bitte prüfe deine Internetverbindung und versuche es noch einmal.', 'netz'); };
        xhr.send(JSON.stringify({ bild: t.ausschnitt, mime: 'image/jpeg', sitzung: sitzung }));
      });
    }
    function balkenStarten(t, auftrag) {
      var start = Date.now();
      var texte = [[0, 'Foto wird analysiert…'], [3500, 'Motiv wird erstellt…'], [11000, 'Feinschliff…'], [22000, 'Gleich fertig…']];
      clearInterval(t.balkenTimer);
      t.balkenTimer = setInterval(function () {
        if (auftrag !== t.auftrag || t.phase !== 'laeuft') { clearInterval(t.balkenTimer); return; }
        var ms = Date.now() - start, p = 92 * (1 - Math.exp(-ms / 7000));
        var b = t.kachel.querySelector('.pmg-balken i'), tx = t.kachel.querySelector('.pmg-kachel-text');
        if (b) b.style.width = p.toFixed(1) + '%';
        if (tx) texte.forEach(function (e) { if (ms >= e[0]) tx.textContent = e[1]; });
      }, 120);
    }
    function zuruecksetzen(t, ohneMerken) {
      t.auftrag++; t.laedt = false; t.phase = 'leer'; t.motiv = null; t.motivUrl = t.id = '';
      t.quelle = null; t.zuschnitt = null; t.ausschnitt = null;
      fehlerZeigen(''); kachelnZeichnen(); felderSetzen(); allesZeichnen();
      if (!ohneMerken) merken();
    }

    // ---------------------------------------------------------------- Merken (Neuladen der Seite)
    // Speicherform: Tier-Auswahl (speicherForm / ausSpeicher)
    function merken() { speicherSchreiben(SPEICHER, auswahl.speicherForm()); }
    function motivLaden(t, id) {
      var auftrag = ++t.auftrag, url = bildBasis(API) + id + '/motiv';
      t.laedt = true; kachelnZeichnen();
      var zeitlimit = new Promise(function (ok, fehl) { setTimeout(function () { fehl(new Error('zeit')); }, 15000); });
      Promise.race([bildLaden(url, true), zeitlimit]).then(function (bild) {
        if (auftrag !== t.auftrag) return;
        t.motiv = gravurEbenen(bild); t.motivUrl = url; t.id = id;
        t.laedt = false; t.phase = 'fertig'; kachelnZeichnen(); felderSetzen(); allesZeichnen();
      }).catch(function () {
        if (auftrag !== t.auftrag) return;
        t.laedt = false; kachelnZeichnen();                 // gespeichertes Motiv bleibt erhalten
        var b = el('button', { type: 'button', class: 'pmg-link', text: 'Erneut laden' });
        b.addEventListener('click', function () { fehlerZeigen(''); if (tiere.indexOf(t) >= 0) motivLaden(t, id); });
        fehlerBox.classList.remove('pmg-fehler--neutral');
        fehlerBox.setAttribute('role', 'alert');
        meldung(fehlerBox, motivVon(t) + ' konnte gerade nicht geladen werden.', b);
      });
    }
    function wiederherstellen() {
      var g = speicherLesen(SPEICHER);
      if (!g || typeof g !== 'object') return;
      auswahl.ausSpeicher(g).forEach(function (e) {
        var t = tiere[0];
        if (e.weiteres) { t = tierAnlegen(); auswahl.anhaengen(t); }
        if (e.name) { t.nameIn.value = String(e.name).slice(0, MAX_NAME); nameZaehlen(t); }
        t.menge = e.menge;
        // Nur ein Motiv von unserem Server mit passender ID übernehmen (URL wird neu gebaut)
        if (e.motiv && !DEMO && motivUrlGueltig(e.motiv.url, e.motiv.id, API)) motivLaden(t, e.motiv.id);
      });
      if (mehrere()) { kachelnZeichnen(); felderSetzen(); allesZeichnen(); } else mengeZeichnen();
    }

    // ---------------------------------------------------------------- Warenkorb absichern
    // Capture-Phase am document: läuft vor UpCart (Capture am Knopf) und vor dem Theme. Gesperrt wird nur, wenn etwas
    // fehlt – sonst übergibt die Übergabe an den Warenkorb (UpCart, Klaviyo und Outbrain laufen ganz normal).
    function zuFeld(feld, fokus) {
      var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var r = feld.getBoundingClientRect();
      feld.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: r.height > window.innerHeight - 40 ? 'start' : 'center' });
      if (fokus) setTimeout(function () { fokus.focus({ preventScroll: true }); }, ruhig ? 0 : 350);
    }
    var sperren = korb.sperren;
    function pruefeVorWarenkorb(e) {
      if (!document.contains(root) || !korb.istKorbEreignis(e)) return;
      if (korb.gesperrt(e)) return;                       // Doppelklick nach dem Fenster-Knopf, Übergabe läuft noch
      var arbeit = tiere.filter(function (t) { return t.phase === 'laeuft' || t.laedt; })[0];
      if (arbeit) {
        sperren(e);
        meldung(hinweis, motivVon(arbeit) + ' wird gerade erstellt. Einen Moment bitte, dann kannst du bestellen.');
        zuFeld(uploadFeld); return;
      }
      var ohne = tiere.filter(function (t) { return t.phase !== 'fertig' || !t.motivUrl; })[0];
      if (ohne) {
        sperren(e);
        if (!mehrere()) { meldung(hinweis, 'Bitte lade zuerst ein Foto deines Tieres hoch.'); zuFeld(uploadFeld, ohne.kachel); return; }
        aktivSetzen(ohne);
        meldung(hinweis, 'Für Haustier ' + nummer(ohne) + ' fehlt noch das Motiv. Lade ein Foto hoch oder entferne es mit dem Papierkorb.');
        zuFeld(uploadFeld, ohne.kachel); return;
      }
      for (var i = 0; i < tiere.length; i++) {
        if (!pruefeName(tiere[i], true)) { sperren(e); aktivSetzen(tiere[i]); zuFeld(tiere[i].nameFeld, tiere[i].nameIn); return; }
      }
      korb.uebergeben(e);                                 // ein Anhänger: Formular des Themes, sonst eigene Anfrage
    }
    document.addEventListener('click', pruefeVorWarenkorb, true);
    document.addEventListener('submit', pruefeVorWarenkorb, true);

    // ---------------------------------------------------------------- Start
    kachelnZeichnen(); felderSetzen();
    function wennBereit() { korb.findeFormular(); galerieFinden(); allesZeichnen(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wennBereit); else wennBereit();
    document.addEventListener('page:loaded', wennBereit);
    wiederherstellen();
    if (document.fonts && document.fonts.load) {
      document.fonts.load('600 40px Poppins').then(allesZeichnen, function () {});
    }
  }

  // ================================================================== Warenkorb-Bilder
  var cache = {}, fertigeBilder = {};
  function vorschauUrl(motivUrl, name) {
    if (!motivUrl) return Promise.resolve(null);
    var key = motivUrl + '|' + name;
    if (cache[key]) return cache[key];
    cache[key] = bildLaden(motivUrl, true).then(function (bild) {
      var c = document.createElement('canvas'); c.width = c.height = 360;
      zeichneAnhaenger(c, { motiv: gravurEbenen(bild), name: name, art: 'thumb', platzhalter: false });
      fertigeBilder[key] = c.toDataURL('image/png');
      return fertigeBilder[key];
    }).catch(function () { delete cache[key]; return null; });
    return cache[key];
  }
  function vorschauAusEbenen(motivUrl, name, ebenen) {
    var key = motivUrl + '|' + name;
    if (!motivUrl || !ebenen || fertigeBilder[key]) return;
    try {
      var c = document.createElement('canvas'); c.width = c.height = 360;
      zeichneAnhaenger(c, { motiv: ebenen, name: name, art: 'thumb', platzhalter: false });
      fertigeBilder[key] = c.toDataURL('image/png'); cache[key] = Promise.resolve(fertigeBilder[key]);
    } catch (e) {}
  }
  function bildSetzen(img, src) {
    // lazysizes (Theme) und React (UpCart) dürfen das Bild nicht zurücksetzen
    ['srcset', 'sizes', 'data-src', 'data-srcset', 'data-sizes', 'data-widths'].forEach(function (a) { img.removeAttribute(a); });
    img.classList.remove('lazyload'); img.classList.add('lazyloaded', 'pmg-warenkorb-bild');
    img.setAttribute('data-pm-geprueft', '1');
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
  }
  function bildTauschen(img, motivUrl, name) {
    if (!img || !motivUrl) return;
    var key = motivUrl + '|' + name;
    if (fertigeBilder[key]) { if (img.getAttribute('src') !== fertigeBilder[key]) bildSetzen(img, fertigeBilder[key]); return; }
    if (img.getAttribute('data-pmg-fuer') === key) return;          // wird gerade erzeugt
    img.setAttribute('data-pmg-fuer', key);
    vorschauUrl(motivUrl, name).then(function (src) {
      if (!src) { img.removeAttribute('data-pmg-fuer'); return; }
      if (img.getAttribute('data-pmg-fuer') === key) bildSetzen(img, src);
    });
  }
  // /cart-Seite und Theme-Schublade: Liquid setzt data-pmg-motiv, -id, -name (+ alle Eigenschaften und
  // die Produkt-ID für die Vertragsprüfung) am Bild. Getauscht wird nur bei einem gültigen Motiv (Status ok).
  function liquidBilder() {
    document.querySelectorAll('img[data-pmg-motiv]').forEach(function (img) {
      var url = img.getAttribute('data-pmg-motiv') || '', id = img.getAttribute('data-pmg-id') || '';
      if (!motivUrlGueltig(url, id)) return;
      var roh = img.getAttribute('data-pmg-eigenschaften');
      if (roh) {
        var liste = null; try { liste = JSON.parse(roh); } catch (e) {}
        if (!liste || gravurStatus(liste, img.getAttribute('data-pmg-produkt')).status !== 'ok') return;
      }
      bildTauschen(img, url, nameKappen(sauberName(img.getAttribute('data-pmg-name'))));
    });
  }
  // UpCart zeichnet mit React neu: nach jedem Update wieder anwenden.
  // positionen = Zeilen mit Motiv, bekannt = alle Zeilen-Schlüssel aus dem letzten /cart.js
  var positionen = {}, bekannt = {}, ladeTimer = null, laeuft = false, nochmal = false;
  function upcartAnwenden() {
    Object.keys(positionen).forEach(function (key) {
      var zeile = document.getElementById(key);
      if (!zeile) return;
      var img = zeile.querySelector('.upcart-product-image-wrapper img') || zeile.querySelector('img');
      bildTauschen(img, positionen[key].motiv, positionen[key].name);
    });
  }
  // Zeilen aus einer Artikel-Liste sofort vormerken: UpCart-Ereignis (cart.items mit productId, kommt VOR dem Neuzeichnen)
  // und Antwort von /cart/add.js (product_id). So bekommt eine neue Zeile ihr Bild schon beim Einfügen – vorher zeigte sie
  // bis zur eigenen /cart.js-Abfrage rund 0,4 s das Produktfoto. Nur ergänzen (gleicher Schlüssel = gleiche Eigenschaften),
  // gleiche Vertragsprüfung wie bei /cart.js; die Wahrheit bleibt warenkorbLaden.
  function zeilenVormerken(items) {
    if (!Array.isArray(items)) return;
    items.forEach(function (it) {
      if (!it || typeof it.key !== 'string' || !it.key || !it.properties || typeof it.properties !== 'object') return;
      var g = gravurStatus(it.properties, it.product_id != null ? it.product_id : it.productId);
      if (g.status === 'ok') positionen[it.key] = { motiv: g.bild, name: nameKappen(g.name) };
    });
  }
  function warenkorbLaden() {
    if (laeuft) { nochmal = true; return; }
    laeuft = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        positionen = {}; bekannt = {};
        (cart.items || []).forEach(function (it) {
          bekannt[it.key] = true;
          // Nur Zeilen mit gültigem Motiv (Vertrag: Status ok, _Motiv-ID passt exakt zur gebauten URL)
          var g = gravurStatus(it.properties || {}, it.product_id);
          if (g.status === 'ok') positionen[it.key] = { motiv: g.bild, name: nameKappen(g.name) };
        });
        upcartAnwenden();
      })
      .catch(function () {})
      .then(function () { laeuft = false; if (nochmal) { nochmal = false; spaeterLaden(); } });
  }
  function spaeterLaden() { clearTimeout(ladeTimer); ladeTimer = setTimeout(warenkorbLaden, 120); }
  function unbekannteZeilen() {
    return Array.prototype.some.call(document.querySelectorAll('.upcart-product-item[id]'), function (n) { return !bekannt[n.id]; });
  }
  ['cart-loaded', 'cart-updated', 'added-to-cart'].forEach(function (n) {
    window.addEventListener('aftersell-upcart:public-events:' + n, function (e) {
      // UpCart schickt den Warenkorb mit (detail.cart.items: key, productId, properties), bevor es neu zeichnet
      if (e && e.detail && e.detail.cart) zeilenVormerken(e.detail.cart.items);
      upcartAnwenden();
      // Nur neu laden, wenn der Drawer Zeilen zeigt, die wir noch nicht kennen (z. B. nach dem Hinzufügen)
      if (n === 'added-to-cart' || unbekannteZeilen()) spaeterLaden();
    });
  });
  document.addEventListener('cart:build', function () { setTimeout(liquidBilder, 60); });
  var beobachterTimer = null, beobachter = null;
  function beobachten() {
    if (beobachter || !window.MutationObserver) return;
    beobachter = new MutationObserver(function (liste) {
      var relevant = liste.some(function (m) {
        if (m.type === 'attributes') return !!(m.target.closest && m.target.closest('.upcart-product-item'));
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && ((n.matches && n.matches('.upcart-product-item, img[data-pmg-motiv]')) ||
                 (n.querySelector && n.querySelector('.upcart-product-item, img[data-pmg-motiv]')));
        });
      });
      if (!relevant) return;
      upcartAnwenden();
      clearTimeout(beobachterTimer);
      beobachterTimer = setTimeout(function () {
        liquidBilder(); upcartAnwenden();                  // sofort mit bekannten Daten
        if (unbekannteZeilen()) spaeterLaden();            // nur bei neuen Zeilen den Warenkorb abfragen
      }, 60);
    });
    beobachter.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  // ================================================================== Start
  function start() {
    document.querySelectorAll('[data-pm-gravur]:not([data-pmg-bereit])').forEach(function (root) {
      root.setAttribute('data-pmg-bereit', '1');
      try {
        var p = new Personalisierung(root);
        if (!p.gesperrt) window.__pmgSperre = false;      // Vorab-Sperre aus dem Liquid-Snippet lösen
      } catch (e) {
        // Ohne funktionierende Personalisierung bleibt der Warenkorb gesperrt (Vorab-Sperre bleibt aktiv)
        if (window.console) console.error('[pm-gravur]', e);
        root.classList.add('pmg');
        root.innerHTML = '<p class="pmg-hinweis" role="alert">Die Personalisierung konnte nicht geladen werden. Bitte lade die Seite neu.</p>';
      }
    });
    liquidBilder(); beobachten();
    if (document.querySelector('.upcart-product-item')) spaeterLaden();
  }
  window.PMGravur.start = start;
  document.addEventListener('shopify:section:load', start);   // Theme-Editor: neu geladener Abschnitt
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
